// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod';

export const zCreateUser = z.object({
    first_name: z.string().register(z.globalRegistry, {
        description: 'User\'s first name'
    }),
    last_name: z.string().register(z.globalRegistry, {
        description: 'User\'s last name'
    }),
    email: z.string().register(z.globalRegistry, {
        description: 'User\'s email address'
    }),
    organization_id: z.int().register(z.globalRegistry, {
        description: 'Organization ID'
    }),
    phone_number: z.string().regex(/^\+[1-9]\d{1,14}$/).register(z.globalRegistry, {
        description: 'Phone number in E.164 format (e.g., +14155551234)'
    }),
    phone_number_extension: z.string().max(10).nullish().default(null),
    role: z.enum([
        'conduit_employee',
        'marketplace_user',
        'clinician',
        'supplier'
    ]).register(z.globalRegistry, {
        description: 'User Role'
    }).optional().default('marketplace_user')
});

export const zSearchMetaData = z.object({
    timestamp: z.string().nullish().default(null),
    function_profile: z.record(z.string(), z.unknown()).nullish().default(null),
    total: z.int().nullish().default(null),
    count: z.int().nullish().default(null),
    q: z.string().nullish().default(null),
    pagination: z.record(z.string(), z.unknown()).nullish().default(null),
    sorting: z.record(z.string(), z.unknown()).nullish().default(null)
});

export const zUserAddress = z.object({
    street: z.string().nullish().default(null),
    complement: z.string().nullish().default(null),
    city: z.string().nullish().default(null),
    state: z.string().nullish().default(null),
    postalCode: z.string().nullish().default(null)
});

export const zUserMetadata = z.object({
    phoneNumber: z.string().nullish().default(null),
    phoneNumberExtension: z.string().nullish().default(null),
    address: zUserAddress.nullish()
});

export const zUserOrganization = z.object({
    organization_id: z.int().register(z.globalRegistry, {
        description: 'Organization ID'
    }),
    name: z.string().nullish().default(null),
    status: z.string().register(z.globalRegistry, {
        description: 'Organization acceptance status'
    }),
    supplier_id: z.int().nullish().default(null)
});

export const zAppMetadata = z.object({
    role: z.string().nullish().default(null),
    organization: zUserOrganization.nullish(),
    permissions: z.array(z.string()).nullish()
});

export const zCreateUserResponse = z.object({
    user_id: z.string().register(z.globalRegistry, {
        description: 'Unique user identifier'
    }),
    first_name: z.string().register(z.globalRegistry, {
        description: 'User\'s first name'
    }),
    last_name: z.string().register(z.globalRegistry, {
        description: 'User\'s last name'
    }),
    email: z.string().register(z.globalRegistry, {
        description: 'User\'s email address'
    }),
    user_metadata: zUserMetadata.nullish(),
    app_metadata: zAppMetadata.nullish(),
    blocked: z.boolean().nullish().default(null),
    logins_count: z.int().nullish().default(null),
    password: z.string().nullish().default(null)
});

export const zCreateUserResponseEnvelope = z.object({
    metadata: zSearchMetaData,
    payload: zCreateUserResponse
});

export const zProductCategory = z.object({
    uuid: z.uuid().register(z.globalRegistry, {
        description: 'Category uuid'
    }),
    name: z.string().register(z.globalRegistry, {
        description: 'Category name'
    })
});

export const zProductEligibility = z.object({
    type: z.string().register(z.globalRegistry, {
        description: 'Carrier type: medicaid, or medicare'
    }),
    template_uuid: z.string().register(z.globalRegistry, {
        description: 'Carrier template uuid'
    }),
    label: z.string().register(z.globalRegistry, {
        description: 'Display label for the carrier type'
    })
});

export const zProduct = z.object({
    name: z.string().register(z.globalRegistry, {
        description: 'Product name'
    }),
    uuid: z.string().register(z.globalRegistry, {
        description: 'Product uuid'
    }),
    description: z.string().nullish(),
    image: z.string().nullish(),
    category: zProductCategory,
    eligibility: z.array(zProductEligibility).register(z.globalRegistry, {
        description: 'List of eligible carrier types'
    })
});

export const zProductListMetadata = z.object({
    timestamp: z.string().register(z.globalRegistry, {
        description: 'UTC timestamp'
    }),
    version: z.int().register(z.globalRegistry, {
        description: 'API Version'
    }),
    page: z.int().register(z.globalRegistry, {
        description: 'Current page number'
    }),
    page_size: z.int().register(z.globalRegistry, {
        description: 'Number of items per page'
    }),
    total_items: z.int().register(z.globalRegistry, {
        description: 'Total number of items'
    }),
    input_parameters: z.unknown().optional()
});

export const zProductListResponse = z.object({
    payload: z.array(zProduct).register(z.globalRegistry, {
        description: 'List of products V3'
    }),
    metadata: zProductListMetadata
});

export const zNpiAddressSchemaResponse = z.object({
    address_1: z.string().nullish(),
    address_2: z.string().nullish(),
    address_purpose: z.string().nullish(),
    address_type: z.string().nullish(),
    city: z.string().nullish(),
    country_code: z.string().nullish(),
    country_name: z.string().nullish(),
    postal_code: z.string().nullish(),
    state: z.string().nullish(),
    telephone_number: z.string().nullish()
});

export const zBasicSchemaResponse = z.object({
    credential: z.string().nullish(),
    enumeration_date: z.string().nullish(),
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    last_updated: z.string().nullish(),
    middle_name: z.string().nullish(),
    name_prefix: z.string().nullish(),
    name_suffix: z.string().nullish(),
    sex: z.string().nullish(),
    sole_proprietor: z.string().nullish(),
    status: z.string().nullish(),
    email: z.string().nullish()
});

export const zTaxonomySchemaResponse = z.object({
    code: z.string().nullish(),
    desc: z.string().nullish(),
    license: z.string().nullish(),
    primary: z.boolean().optional(),
    state: z.string().nullish(),
    taxonomy_group: z.string().nullish()
});

export const zProviderResponse = z.object({
    addresses: z.array(zNpiAddressSchemaResponse).optional(),
    basic: zBasicSchemaResponse.optional(),
    created_epoch: z.string().nullish(),
    endpoints: z.array(z.unknown()).optional(),
    enumeration_type: z.string().nullish(),
    identifiers: z.array(z.unknown()).optional(),
    last_updated_epoch: z.string().nullish(),
    number: z.string().nullish(),
    other_names: z.array(z.unknown()).optional(),
    practiceLocations: z.array(z.unknown()).optional(),
    taxonomies: z.array(zTaxonomySchemaResponse).optional()
});

export const zNpiAddressSchemaResponse1 = z.object({
    uuid: z.string().nullish().default(null),
    address_1: z.string().nullish().default(null),
    address_2: z.string().nullish().default(null),
    city: z.string().nullish().default(null),
    state: z.string().nullish().default(null),
    postal_code: z.string().nullish().default(null),
    is_active: z.boolean().nullish().default(true)
});

export const zNpiResponse = z.object({
    addresses: z.array(zNpiAddressSchemaResponse1).optional(),
    number: z.string().nullish().default(null),
    uuid: z.string().nullish().default(null),
    credential: z.string().nullish().default(null),
    first_name: z.string().nullish().default(null),
    last_name: z.string().nullish().default(null),
    sex: z.string().nullish().default(null),
    status: z.string().nullish().default(null),
    email: z.string().nullish().default(null),
    phone: z.string().nullish().default(null)
});

export const zBaseMetadata = z.object({
    timestamp: z.string().nullish().default(null),
    duration: z.string().nullish().default(null),
    total: z.int().nullish().default(null),
    count: z.int().nullish().default(null)
});

export const zSearchNpiResponse = z.object({
    payload: z.array(zNpiResponse).register(z.globalRegistry, {
        description: 'Providers'
    }),
    metadata: zBaseMetadata.nullish()
});

export const zUserDetailsResponse = z.object({
    user_id: z.string().register(z.globalRegistry, {
        description: 'Unique user identifier'
    }),
    first_name: z.string().register(z.globalRegistry, {
        description: 'User\'s first name'
    }),
    last_name: z.string().register(z.globalRegistry, {
        description: 'User\'s last name'
    }),
    email: z.string().register(z.globalRegistry, {
        description: 'User\'s email address'
    }),
    user_metadata: zUserMetadata.nullish(),
    app_metadata: zAppMetadata.nullish(),
    blocked: z.boolean().nullish().default(null),
    logins_count: z.int().nullish().default(null),
    new_order_count: z.int().nullish().default(null),
    resupply_order_count: z.int().nullish().default(null),
    last_order_date: z.string().nullish().default(null)
});

export const zListUserResponse = z.object({
    metadata: zSearchMetaData,
    payload: z.array(zUserDetailsResponse)
});

export const zVerifyStartBody = z.object({
    phone_number: z.string().regex(/^\+[1-9]\d{1,14}$/).register(z.globalRegistry, {
        description: 'Phone number in E.164 format (e.g., +14155551234)'
    })
});

export const zVerifyStartResponse = z.object({
    success: z.boolean().register(z.globalRegistry, {
        description: 'Whether the verification code was sent successfully'
    }),
    message: z.string().register(z.globalRegistry, {
        description: 'Response message'
    })
});

export const zVerifyCheckBody = z.object({
    phone_number: z.string().regex(/^\+[1-9]\d{1,14}$/).register(z.globalRegistry, {
        description: 'Phone number in E.164 format (e.g., +14155551234)'
    }),
    code: z.string().min(1).max(6).register(z.globalRegistry, {
        description: 'Verification code to check'
    })
});

export const zVerifyCheckResponse = z.object({
    success: z.boolean().register(z.globalRegistry, {
        description: 'Whether the verification was successful'
    }),
    message: z.string().register(z.globalRegistry, {
        description: 'Response message'
    })
});

export const zOrderAddress = z.object({
    street: z.string(),
    city: z.string(),
    state: z.string(),
    zip_code: z.string(),
    complement: z.string().nullish()
});

export const zOrderPhysician = z.object({
    first_name: z.string(),
    last_name: z.string(),
    npi: z.string(),
    email: z.string(),
    phone: z.string().nullish(),
    patient_last_visit: z.string().nullish(),
    address: zOrderAddress
});

export const zOrderPatient = z.object({
    patient_id: z.int(),
    first_name: z.string(),
    last_name: z.string(),
    email: z.string().nullish(),
    phone_number: z.string().nullish(),
    gender: z.string(),
    dob: z.string()
});

export const zOrderContact = z.object({
    first_name: z.string(),
    last_name: z.string(),
    phone_type: z.string(),
    phone_number: z.string(),
    email: z.string().nullish(),
    preferred_language: z.string(),
    relationship: z.string()
});

export const zOrderEligibility = z.object({
    status: z.string(),
    reason: z.string().nullish(),
    checked_on: z.string()
});

export const zInsurance = z.object({
    member_id: z.string(),
    group_number: z.string(),
    plan_code: z.string(),
    name: z.string(),
    state: z.string(),
    eligibility: zOrderEligibility.nullish(),
    created_at: z.string(),
    modified_at: z.string().nullish(),
    fr_trace_id: z.string().nullish(),
    trace_id: z.int().nullish(),
    frhc_id: z.int().nullish(),
    carrier_priority: z.int().nullish(),
    carrier_type: z.string().nullish(),
    additional_coverage: z.unknown().optional(),
    effective_date: z.string().nullish(),
    manually_entered: z.boolean().nullish(),
    manually_verified_at: z.string().nullish(),
    manually_verified_by: z.string().nullish(),
    manually_verified_source: z.enum(['INSURANCE_CARD', 'OTHER']).optional(),
    is_other: z.boolean().nullish(),
    referral_submitted: z.boolean().nullish(),
    message: z.string().nullish(),
    termination_date: z.string().nullish(),
    card_front: z.string().nullish(),
    card_back: z.string().nullish()
});

export const zInsuranceHistory = z.object({
    discovered: z.array(zInsurance)
});

export const zOrderEsignatureStatus = z.object({
    status: z.string(),
    created_at: z.string()
});

export const zOrderEsignature = z.object({
    status: z.string(),
    label: z.string(),
    esignature_id: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
    order_esignature_status: z.array(zOrderEsignatureStatus)
});

export const zOrderUser = z.object({
    first_name: z.string(),
    last_name: z.string(),
    user_id: z.string(),
    role: z.string().nullish(),
    organization_id: z.int(),
    organization_name: z.string().nullish(),
    email: z.string(),
    phone: z.string().nullish(),
    created_at: z.string(),
    updated_at: z.string().nullish()
});

export const zOrderStatus = z.object({
    status: z.string(),
    reason: z.string().nullish(),
    description: z.string().nullish(),
    created_at: z.string()
});

export const zOrderRequestChange = z.object({
    reason: z.string(),
    description: z.string().nullish(),
    resolved: z.boolean().nullish()
});

export const zSupplier = z.object({
    supplier_id: z.int(),
    name: z.string(),
    email: z.string().nullish(),
    phone: z.string(),
    address: zOrderAddress,
    npi: z.string(),
    organization_id: z.int(),
    brightree_nickname: z.string().nullish(),
    created_at: z.string().nullish(),
    updated_at: z.string().nullish()
});

export const zOrderIcdCode = z.object({
    code: z.string(),
    description: z.string()
});

export const zOrderItemProperty = z.object({
    key: z.string(),
    value: z.string(),
    validation_type: z.string().nullish()
});

export const zProductProperty = z.object({
    key: z.string(),
    display_text: z.string(),
    type: z.string(),
    required: z.boolean(),
    values: z.unknown(),
    condition: z.string().nullish(),
    depends_on: z.string().nullish(),
    validation_type: z.string().nullish()
});

export const zVariantAttribute = z.object({
    key: z.string(),
    value: z.string()
});

export const zNewVariant = z.object({
    key: z.string(),
    hcpc: z.array(z.string()),
    attributes: z.array(zVariantAttribute)
});

export const zProductImages = z.object({
    square: z.string().nullish(),
    thumbnail: z.string().nullish()
});

export const zOrderItem = z.object({
    product_id: z.string(),
    icds: z.array(zOrderIcdCode).nullish(),
    hcpc_code: z.array(z.string()),
    quantity: z.int(),
    refill_amount: z.int(),
    key: z.string(),
    title: z.string(),
    description: z.string(),
    selected_properties: z.array(zOrderItemProperty),
    selected_checkout_properties: z.array(zOrderItemProperty),
    categories: z.array(z.string()),
    properties: z.array(zProductProperty).nullish(),
    variants: z.array(zNewVariant).nullish(),
    images: z.array(zProductImages).nullish()
});

export const zTelehealthAppointment = z.object({
    scheduled_for: z.string().nullish(),
    completed_at: z.string().nullish(),
    error: z.string().nullish(),
    updated_at: z.string().nullish(),
    provider_name: z.string().nullish()
});

export const zTelehealth = z.object({
    appointments: z.array(zTelehealthAppointment)
});

export const zPrescriptionMetadata = z.object({
    signing_date: z.string().nullish().default(null),
    expiration_date: z.string().nullish().default(null),
    source: z.string().nullish().default(null),
    reference: z.string().nullish().default(null)
});

export const zFulfillment = z.object({
    id: z.string(),
    order_id: z.int(),
    hcpc: z.string(),
    is_authorized: z.boolean().optional(),
    is_active: z.boolean().optional(),
    submitted_by: z.string().optional(),
    submitted_via: z.string().optional(),
    authorization_fingerprint: z.string().optional(),
    authorization_date_embargo: z.iso.datetime(),
    authorization_date_start: z.iso.datetime().optional(),
    authorization_date_complete: z.iso.datetime().optional(),
    authorization_lock_expiration: z.iso.datetime().optional(),
    authorization_expiration: z.iso.datetime().optional(),
    authorization_status: z.string().optional(),
    json_data: z.record(z.string(), z.unknown()).optional()
});

export const zAppointmentProvider = z.object({
    name: z.string(),
    phone_number: z.string()
});

export const zAppointment = z.object({
    scheduled_time: z.string(),
    timezone: z.string(),
    provider: zAppointmentProvider
});

export const zOrderResponse = z.object({
    id: z.int(),
    public_id: z.string().nullish().default(null),
    type: z.string(),
    status: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
    last_status_change: z.string(),
    additional_information: z.string().nullish(),
    physician: zOrderPhysician.nullish(),
    patient: zOrderPatient,
    primary_contact: zOrderContact,
    secondary_contact: zOrderContact.nullish(),
    shipping_address: zOrderAddress,
    insurance: zInsurance,
    secondary_insurance: zInsurance.nullish(),
    other_insurances: z.array(zInsurance).nullish(),
    insurance_history: zInsuranceHistory.nullish(),
    esignature: zOrderEsignature.nullish(),
    user: zOrderUser,
    assignees: z.record(z.string(), z.string()).nullish(),
    order_status: z.array(zOrderStatus),
    requested_changes: z.array(zOrderRequestChange).nullish(),
    supplier: zSupplier,
    items: z.array(zOrderItem),
    telehealth: zTelehealth.nullish(),
    telehealth_partner_id: z.int().nullish(),
    telehealth_partner: z.string().nullish(),
    clinical_intake_type: z.string().nullish(),
    parent_order: z.int().nullish(),
    is_resupply: z.boolean().nullish(),
    resupply_order: z.int().nullish(),
    prescription_order: z.int().nullish(),
    api_order_uuid: z.string().nullish(),
    authorization_date: z.string().nullish(),
    prescription_expiration: z.string().nullish(),
    prescription_metadata: zPrescriptionMetadata.nullish(),
    target_ship_date: z.string().nullish(),
    errors: z.unknown().optional(),
    fulfillments: z.array(zFulfillment).optional(),
    appointment: zAppointment.nullish(),
    tracking_url: z.string().nullish()
});

export const zOrderListResponse = z.object({
    metadata: z.record(z.string(), z.unknown()).optional(),
    payload: z.array(zOrderResponse).optional()
});

export const zPatientInput = z.object({
    first_name: z.string(),
    last_name: z.string(),
    dob: z.iso.date(),
    phone_number: z.string().nullish(),
    email: z.string().nullish(),
    gender: z.enum([
        'Male',
        'Female',
        'Other'
    ]).optional()
});

export const zAddressInput = z.object({
    street: z.string(),
    city: z.string(),
    state: z.string(),
    zip_code: z.string(),
    complement: z.string().nullish().default(null)
});

export const zPhysicianInput = z.object({
    first_name: z.string(),
    last_name: z.string(),
    npi: z.string(),
    phone: z.string().nullish(),
    email: z.email().nullish(),
    address: zAddressInput.nullish()
});

export const zInsuranceInput = z.object({
    member_id: z.string(),
    group_number: z.string(),
    plan_code: z.string(),
    name: z.string(),
    state: z.string()
});

export const zContactInput = z.object({
    first_name: z.string(),
    last_name: z.string(),
    phone_number: z.string(),
    email: z.email().nullish().default(null),
    phone_type: z.enum([
        'Mobile',
        'Landline',
        'Office'
    ]),
    preferred_language: z.enum([
        'English',
        'Spanish',
        'Russian',
        'Chinese',
        'Arabic',
        'Other'
    ]),
    relationship: z.enum([
        'Self',
        'Family Member',
        'Aide',
        'Coordinator',
        'Case Manager',
        'Health Proxy',
        'Other'
    ])
});

export const zProductInput = z.object({
    product_id: z.string(),
    variant_key: z.string().nullish().default(null),
    quantity: z.int().optional(),
    refill_amount: z.int().optional()
});

export const zCreateOrder = z.object({
    type: z.enum(['TELEHEALTH', 'ORDINARY']).optional(),
    patient: zPatientInput,
    physician: zPhysicianInput.nullish(),
    insurance: zInsuranceInput,
    secondary_insurance: zInsuranceInput.nullish(),
    shipping_address: zAddressInput,
    primary_contact: zContactInput.nullish(),
    secondary_contact: zContactInput.nullish(),
    legacy_supplier_id: z.int().nullish(),
    items: z.array(zProductInput),
    additional_information: z.string().optional(),
    clinical_intake_type: z.enum([
        'TELEHEALTH_REFERRER_PATIENT_SELF_SCHEDULES',
        'TELEHEALTH_REFERRER_SCHEDULES',
        'SIGNED_DOCUMENTATION',
        'E_PRESCRIBE'
    ]).optional(),
    telehealth_scheduled_time: z.iso.datetime().nullish().default(null),
    telehealth_provider_id: z.string().nullish().default(null),
    telehealth_timezone: z.string().nullish().default(null),
    telehealth_contact_type: z.string().nullish().default(null),
    note: z.string().max(2000).nullish().default(null),
    source_conversation_id: z.string().nullish().default(null),
    insurance_gated: z.boolean().optional().default(false)
});

export const zOrderDetailResponse = z.object({
    metadata: z.record(z.string(), z.unknown()).optional(),
    payload: zOrderResponse.optional()
});

export const zSupplier1 = z.object({
    uuid: z.string(),
    name: z.string(),
    description: z.string().optional(),
    npi: z.string().optional(),
    status: z.string().optional(),
    media: z.unknown().optional(),
    contact: z.unknown().optional(),
    address: z.unknown().optional(),
    zip_code: z.string().optional(),
    city: z.string().optional(),
    state: z.string().optional(),
    legacy_id: z.int().optional(),
    integrations: z.record(z.string(), z.unknown()).optional()
});

export const zCreateOrganizationAddress = z.object({
    street: z.string().max(100),
    complement: z.string().max(100).nullish().default(null),
    city: z.string().max(100),
    state: z.string().max(100),
    zip: z.string().max(5)
});

export const zCreateOrganization = z.object({
    name: z.string().max(100),
    type: z.string().max(100).optional().default('Other'),
    phone_number: z.string().max(20).nullish().default(null),
    phone_number_extension: z.string().max(10).nullish().default(null),
    address: zCreateOrganizationAddress.optional()
});

export const zOrganizationDetailsMetadata = z.object({
    version: z.int().register(z.globalRegistry, {
        description: 'API version'
    }),
    timestamp: z.string().register(z.globalRegistry, {
        description: 'UTC timestamp'
    })
});

export const zOrganizationAddress = z.object({
    street: z.string().register(z.globalRegistry, {
        description: 'Street address'
    }),
    city: z.string().register(z.globalRegistry, {
        description: 'City'
    }),
    state: z.string().register(z.globalRegistry, {
        description: 'State'
    }),
    zip: z.string().register(z.globalRegistry, {
        description: 'ZIP code'
    }),
    complement: z.string().nullish().default(null)
});

export const zOrganization = z.object({
    organization_id: z.string().register(z.globalRegistry, {
        description: 'Organization ID'
    }),
    name: z.string().register(z.globalRegistry, {
        description: 'Organization name'
    }),
    user_count: z.int().register(z.globalRegistry, {
        description: 'Number of users'
    }),
    new_order_count: z.int().register(z.globalRegistry, {
        description: 'Count of new orders'
    }),
    resupply_order_count: z.int().register(z.globalRegistry, {
        description: 'Count of resupply orders'
    }),
    status: z.string().register(z.globalRegistry, {
        description: 'Organization status'
    }),
    phone_number: z.string().nullish().default(null),
    phone_number_extension: z.string().nullish().default(null),
    address: zOrganizationAddress.nullish(),
    last_order_date: z.string().nullish().default(null),
    created_at: z.string().nullish().default(null)
});

export const zOrganizationDetailsResponse = z.object({
    metadata: zOrganizationDetailsMetadata,
    payload: zOrganization
});

export const zCart = z.object({
    cart: z.record(z.string(), z.unknown())
});

export const zSupplierListMetaData = z.object({
    timestamp: z.string().register(z.globalRegistry, {
        description: 'UTC timestamp'
    }),
    count: z.int().register(z.globalRegistry, {
        description: 'Number of records returned'
    }),
    function_profile: z.record(z.string(), z.unknown()).nullish().default(null)
});

export const zSupplierResponse = z.object({
    uuid: z.string().register(z.globalRegistry, {
        description: 'Unique identifier for the supplier'
    }),
    name: z.string().register(z.globalRegistry, {
        description: 'Supplier name'
    }),
    description: z.string().nullish().default(null),
    npi: z.string().nullish().default(null),
    status: z.string().nullish().default(null),
    media: z.record(z.string(), z.unknown()).nullish().default(null),
    contact: z.record(z.string(), z.unknown()).nullish().default(null),
    address: z.record(z.string(), z.unknown()).nullish().default(null),
    zip_code: z.string().nullish().default(null),
    city: z.string().nullish().default(null),
    state: z.string().nullish().default(null),
    legacy_id: z.int().nullish().default(null)
});

export const zSupplierListResponse = z.object({
    metadata: zSupplierListMetaData,
    payload: z.array(zSupplierResponse).register(z.globalRegistry, {
        description: 'List of suppliers'
    })
});

export const zUserSessionSaveRequest = z.object({
    email: z.string().register(z.globalRegistry, {
        description: 'User email address'
    }),
    dob: z.string().register(z.globalRegistry, {
        description: 'Date of birth (used for session verification)'
    }),
    data: z.record(z.string(), z.unknown()).register(z.globalRegistry, {
        description: 'Dictionary of user session data'
    })
});

export const zUserSessionSaveResponse = z.object({
    token: z.string().register(z.globalRegistry, {
        description: 'Session token for subsequent verify/preview requests'
    })
});

export const zBillingInput = z.object({
    order_id: z.int()
});

export const zOrdersBillingInput = z.object({
    orders: z.array(zBillingInput),
    only_authorized: z.boolean().optional().default(true)
});

export const zAuditMetadata = z.object({
    timestamp: z.string(),
    product_uuid: z.string().nullish()
});

export const zAuditResponse = z.object({
    metadata: zAuditMetadata.optional(),
    payload: z.unknown().optional()
});

export const zCategory = z.object({
    category_name: z.string().optional(),
    parent_category: z.lazy((): any => zCategory).nullish()
});

export const zImage = z.object({
    square: z.string().optional(),
    thumbnail: z.string().optional()
});

export const zProperty = z.object({
    depends_on: z.string().optional(),
    display_text: z.string().optional(),
    key: z.string().optional(),
    required: z.boolean().optional(),
    type: z.string().optional(),
    validation_type: z.string().nullish(),
    value: z.unknown().optional(),
    values: z.unknown().optional()
});

export const zVariant = z.object({
    key: z.string().optional()
});

export const zConduitHealthIntegration = z.object({
    active: z.boolean().optional(),
    categories: zCategory.optional(),
    checkout_properties: z.array(z.unknown()).optional(),
    images: z.array(zImage).optional(),
    legacy_id: z.string().optional(),
    properties: z.array(zProperty).optional(),
    suppliers: z.array(z.int()).optional(),
    variants: z.array(zVariant).optional()
});

export const zMedia = z.object({
    type: z.string().optional(),
    value: z.string().optional()
});

export const zProduct1 = z.object({
    created_at: z.iso.datetime().optional(),
    description: z.string().optional(),
    integrations: z.record(z.string(), zConduitHealthIntegration).optional(),
    is_active: z.boolean().optional(),
    is_visible: z.boolean().optional(),
    json_data: z.record(z.string(), z.unknown()).optional(),
    media: z.record(z.string(), zMedia).optional(),
    modified_at: z.iso.datetime().optional(),
    name: z.string().optional(),
    properties: z.record(z.string(), z.unknown()).optional(),
    status: z.string().optional(),
    uuid: z.string().optional(),
    test: z.string().optional()
});

export const zSearchProductResult = z.object({
    page: z.int().optional(),
    total: z.int().optional(),
    categories: z.unknown().optional(),
    searchProducts: z.array(zProduct1).optional()
});

export const zOrderStatusesMetadata = z.object({
    version: z.int().register(z.globalRegistry, {
        description: 'API version'
    }),
    timestamp: z.string().register(z.globalRegistry, {
        description: 'UTC timestamp'
    })
});

export const zOrderStatusesResponse = z.object({
    metadata: zOrderStatusesMetadata,
    payload: z.array(z.string()).register(z.globalRegistry, {
        description: 'List of valid V2 order statuses'
    })
});

export const zMediaItem = z.object({
    type: z.string(),
    value: z.string()
});

export const zMediaImage = z.object({
    square: zMediaItem.nullish(),
    thumbnail: zMediaItem.nullish()
});

export const zCategory1 = z.object({
    uuid: z.uuid(),
    label: z.string(),
    parent_uuid: z.uuid().nullish(),
    parent_category: z.lazy((): any => zCategory1).nullish()
});

export const zProductSearchResult = z.object({
    uuid: z.uuid(),
    name: z.string(),
    description: z.string().nullish(),
    status: z.string(),
    media: zMediaImage.nullish(),
    categories: z.array(zCategory1)
});

export const zSearchResults = z.object({
    total: z.int(),
    products: z.array(zProductSearchResult)
});

export const zSearchMetaData1 = z.object({
    timestamp: z.string().nullish().default(null),
    duration: z.string().nullish().default(null),
    total: z.int().nullish().default(null),
    count: z.int().nullish().default(null),
    q: z.string().nullish().default(null),
    pagination: z.record(z.string(), z.unknown()).nullish().default(null),
    sorting: z.record(z.string(), z.unknown()).nullish().default(null),
    queries: z.unknown().register(z.globalRegistry, {
        description: 'Query details'
    }).optional().default(null),
    function_profile: z.record(z.string(), z.unknown()).nullish().default(null),
    input_parameters: z.record(z.string(), z.unknown()).nullish().default(null)
});

export const zInsuranceResponse = z.object({
    id: z.int().nullish().default(null),
    member_id: z.string().nullish().default(null),
    plan_code: z.string().nullish().default(null),
    group_number: z.string().nullish().default(null),
    name: z.string().nullish().default(null),
    state: z.string().nullish().default(null)
});

export const zContactResponse = z.object({
    id: z.int().nullish().default(null),
    first_name: z.string().nullish().default(null),
    last_name: z.string().nullish().default(null),
    phone_number: z.string().nullish().default(null),
    phone_type: z.string().nullish().default(null),
    email: z.string().nullish().default(null),
    preferred_language: z.string().nullish().default(null),
    patient_relationship: z.string().nullish().default(null)
});

export const zAddressResponse = z.object({
    street: z.string().nullish().default(null),
    city: z.string().nullish().default(null),
    state: z.string().nullish().default(null),
    zip_code: z.string().nullish().default(null),
    complement: z.string().nullish().default(null)
});

export const zReferralResponse = z.object({
    user_id: z.string().register(z.globalRegistry, {
        description: 'Referral id'
    }),
    organization_id: z.int().register(z.globalRegistry, {
        description: 'Referral organization id'
    }),
    first_name: z.string().register(z.globalRegistry, {
        description: 'Referral First name'
    }),
    last_name: z.string().register(z.globalRegistry, {
        description: 'Referral Last name'
    }),
    email: z.string().register(z.globalRegistry, {
        description: 'Referral email'
    }),
    organization_name: z.string().nullish().default(null)
});

export const zPatientResponse = z.object({
    id: z.int().nullish().default(null),
    first_name: z.string().nullish().default(null),
    last_name: z.string().nullish().default(null),
    gender: z.string().nullish().default(null),
    dob: z.string().nullish().default(null),
    insurances: z.array(zInsuranceResponse).nullish().default(null),
    contacts: z.array(zContactResponse).nullish().default(null),
    addresses: z.array(zAddressResponse).nullish().default(null),
    referral: zReferralResponse.nullish()
});

export const zSearchPatientResultsResponse = z.object({
    metadata: zSearchMetaData1,
    payload: z.array(zPatientResponse).register(z.globalRegistry, {
        description: 'List of patient results'
    })
});

export const zCreatePlan = z.object({
    carrier_coverage_zone_uuid: z.uuid(),
    plan_type: z.enum([
        'medicare',
        'medicare_advantage',
        'medicaid',
        'medicaid_managed_care'
    ]),
    name: z.string().max(100),
    frhc_id: z.string().max(50).nullish().default(null),
    candid_payer_id: z.string().max(50).nullish().default(null),
    candid_que_payer_id: z.string().max(50).nullish().default(null)
});

export const zPlanDetailMetadata = z.object({
    version: z.int().register(z.globalRegistry, {
        description: 'API version'
    }),
    timestamp: z.string().register(z.globalRegistry, {
        description: 'UTC timestamp'
    }),
    function_profile: z.record(z.string(), z.unknown()).nullish().default(null)
});

export const zPlanCodeResponse = z.object({
    uuid: z.string().register(z.globalRegistry, {
        description: 'Plan code UUID'
    }),
    plan_uuid: z.string().register(z.globalRegistry, {
        description: 'Parent plan UUID'
    }),
    code: z.string().register(z.globalRegistry, {
        description: 'Plan code'
    }),
    is_active: z.boolean().register(z.globalRegistry, {
        description: 'Active flag'
    }),
    is_visible: z.boolean().register(z.globalRegistry, {
        description: 'Visible flag'
    }),
    created_at: z.string().nullish().default(null),
    modified_at: z.string().nullish().default(null)
});

export const zPlanDetailPayload = z.object({
    uuid: z.string().register(z.globalRegistry, {
        description: 'Plan UUID'
    }),
    carrier_coverage_zone_uuid: z.string().register(z.globalRegistry, {
        description: 'Carrier coverage zone UUID'
    }),
    plan_type: z.string().register(z.globalRegistry, {
        description: 'Plan type'
    }),
    name: z.string().register(z.globalRegistry, {
        description: 'Plan name'
    }),
    is_active: z.boolean().register(z.globalRegistry, {
        description: 'Active flag'
    }),
    is_visible: z.boolean().register(z.globalRegistry, {
        description: 'Visible flag'
    }),
    carrier_name: z.string().nullish().default(null),
    state: z.string().nullish().default(null),
    plan_codes: z.array(zPlanCodeResponse).register(z.globalRegistry, {
        description: 'Plan codes belonging to this plan'
    }).optional(),
    frhc_id: z.string().nullish().default(null),
    candid_payer_id: z.string().nullish().default(null),
    candid_que_payer_id: z.string().nullish().default(null),
    created_at: z.string().nullish().default(null),
    modified_at: z.string().nullish().default(null)
});

export const zPlanDetailResponse = z.object({
    metadata: zPlanDetailMetadata,
    payload: zPlanDetailPayload
});

export const zUserSessionVerifyRequest = z.object({
    dob: z.string().register(z.globalRegistry, {
        description: 'Date of birth to validate token'
    })
});

export const zUserSessionVerifyResponse = z.object({
    data: z.record(z.string(), z.unknown()).register(z.globalRegistry, {
        description: 'Dictionary of user session data'
    })
});

export const zDaysAvailableResponse = z.object({
    payload: z.array(z.string()).register(z.globalRegistry, {
        description: 'List of dates (YYYY-MM-DD) with available slots'
    }),
    metadata: z.record(z.string(), z.unknown()).nullish().default(null)
});

/**
 * Insurance Details
 */
export const zInsurance1 = z.object({
    status: z.string().optional(),
    state: z.string().optional(),
    uuid: z.uuid().optional(),
    name: z.string().max(100),
    is_template: z.boolean().optional(),
    percentage_modifier: z.int().nullish(),
    integrations: z.unknown().optional(),
    json_data: z.unknown().optional(),
    created_at: z.iso.datetime().nullish(),
    modified_at: z.iso.datetime().nullish(),
    is_visible: z.boolean().optional(),
    is_active: z.boolean().optional(),
    slug: z.string().max(255)
}).register(z.globalRegistry, {
    description: 'Insurance Details'
});

export const zOrderAuthorization = z.object({
    order_id: z.int(),
    fulfillment_ids: z.array(z.string())
});

export const zOrdersAuthorizationInput = z.object({
    authorizations: z.array(zOrderAuthorization)
});

export const zAuthorizationResponse = z.object({
    metadata: z.record(z.string(), z.unknown()).optional(),
    payload: z.array(z.record(z.string(), z.unknown())).optional(),
    errors: z.array(z.record(z.string(), z.unknown())).optional()
});

export const zPagination = z.object({
    page: z.int().optional().default(0),
    limit: z.int().optional().default(10)
});

export const zSort = z.object({
    sort_by: z.string().optional(),
    sort_direction: z.enum(['asc', 'desc']).register(z.globalRegistry, {
        description: 'Results sort directions (asc or desc)'
    }).optional()
});

export const zSearchSupplierMetaData = z.object({
    timestamp: z.string().optional(),
    duration: z.string(),
    total: z.int(),
    count: z.int(),
    query: z.string().optional(),
    pagination: zPagination.optional(),
    sorting: zSort.optional(),
    function_profile: z.unknown().optional()
});

/**
 * Supplier Details
 */
export const zSupplierResult = z.object({
    status: z.string().optional(),
    name: z.string().max(100),
    description: z.string().nullish(),
    npi: z.string().max(10),
    tax_id: z.string().max(20).nullish(),
    integrations: z.unknown().optional(),
    contact: z.unknown().optional(),
    media: z.unknown().optional(),
    address: z.unknown().optional(),
    json_data: z.unknown().optional(),
    zip_code: z.string().max(10),
    city: z.string().max(50),
    state: z.string().max(2),
    uuid: z.uuid().optional(),
    created_at: z.iso.datetime().nullish(),
    modified_at: z.iso.datetime().nullish(),
    is_visible: z.boolean().optional(),
    is_active: z.boolean().optional(),
    slug: z.string().max(255)
}).register(z.globalRegistry, {
    description: 'Supplier Details'
});

export const zSearchSupplierResults = z.object({
    metadata: zSearchSupplierMetaData.optional(),
    payload: z.array(zSupplierResult).optional(),
    label: z.string().optional()
});

export const zMetaData = z.object({
    timestamp: z.string().register(z.globalRegistry, {
        description: 'UTC timestamp'
    }),
    version: z.int().register(z.globalRegistry, {
        description: 'API Version'
    })
});

export const zPayload = z.object({
    message: z.string()
});

export const zHeartbeat = z.object({
    metadata: zMetaData.optional(),
    payload: z.array(zPayload).optional()
});

export const zSearchSupplierMetaData1 = z.object({
    total: z.int().register(z.globalRegistry, {
        description: 'Total number of matching records'
    }),
    count: z.int().register(z.globalRegistry, {
        description: 'Number of records returned'
    }),
    timestamp: z.string().nullish().default(null),
    query: z.string().nullish().default(null),
    pagination: z.record(z.string(), z.unknown()).nullish().default(null),
    sorting: z.record(z.string(), z.unknown()).nullish().default(null),
    function_profile: z.record(z.string(), z.unknown()).nullish().default(null)
});

export const zSearchSupplierResponse = z.object({
    metadata: zSearchSupplierMetaData1,
    payload: z.array(zSupplierResponse).register(z.globalRegistry, {
        description: 'List of supplier results'
    })
});

export const zGetNpiResponse = z.object({
    payload: zNpiResponse,
    metadata: zBaseMetadata.nullish()
});

export const zNpiAddressRequest = z.object({
    street: z.string().register(z.globalRegistry, {
        description: 'Street address'
    }),
    city: z.string().register(z.globalRegistry, {
        description: 'City'
    }),
    state: z.string().register(z.globalRegistry, {
        description: 'State abbreviation'
    }),
    zip_code: z.string().register(z.globalRegistry, {
        description: 'ZIP code'
    }),
    complement: z.string().nullish().default(null)
});

export const zUpdateNpiInput = z.object({
    email: z.string().register(z.globalRegistry, {
        description: 'Provider email address'
    }),
    phone: z.string().nullish().default(null),
    addresses: zNpiAddressRequest.nullish()
});

export const zPatientEligibilityInput = z.object({
    first_name: z.string(),
    last_name: z.string(),
    date_of_birth: z.string().register(z.globalRegistry, {
        description: 'Date of birth in YYYY-MM-DD format'
    }),
    gender: z.string().register(z.globalRegistry, {
        description: 'Gender identity of the person (required for eligibility verification)'
    }),
    address_line1: z.string().nullish(),
    address_line2: z.string().nullish(),
    city: z.string().nullish(),
    state: z.string().nullish(),
    zip: z.string().nullish()
});

export const zDiscoveryInput = z.object({
    patient: zPatientEligibilityInput
});

export const zInsuranceMetaData = z.object({
    timestamp: z.string().register(z.globalRegistry, {
        description: 'UTC timestamp'
    }),
    version: z.int().register(z.globalRegistry, {
        description: 'API Version'
    }),
    function_profile: z.unknown().optional(),
    input_parameters: z.unknown().optional()
});

export const zInsuranceDiscoveryResponse = z.object({
    name: z.string(),
    member_id: z.string(),
    carrier_type: z.enum([
        'medicare',
        'medicare_advantage',
        'medicaid',
        'medicaid_managed_care'
    ]),
    state: z.string(),
    verification_key: z.string(),
    verified: z.boolean()
});

export const zInsuranceEligibilityDiscoveryResponse = z.object({
    metadata: zInsuranceMetaData.optional(),
    payload: z.array(zInsuranceDiscoveryResponse)
});

export const zInsuranceEligibilityInput = z.object({
    member_id: z.string().optional(),
    uuid: z.string().register(z.globalRegistry, {
        description: 'The UUID of the carrier_coverage_zone'
    }).optional(),
    carrier_type: z.string().optional(),
    fingerprint: z.string()
});

export const zEligibilityInput = z.object({
    patient: zPatientEligibilityInput.optional(),
    insurance: z.array(zInsuranceEligibilityInput)
});

export const zInsuranceVerificationResponse = z.object({
    name: z.string(),
    member_id: z.string(),
    carrier_type: z.enum([
        'medicare',
        'medicare_advantage',
        'medicaid',
        'medicaid_managed_care'
    ]),
    state: z.string(),
    verification_key: z.string(),
    verified: z.boolean(),
    verifiable: z.boolean(),
    fingerprint: z.string()
});

export const zInsuranceEligibilityVerificationResponse = z.object({
    metadata: zInsuranceMetaData.optional(),
    payload: z.array(zInsuranceVerificationResponse)
});

export const zTimeSlot = z.object({
    start: z.string().register(z.globalRegistry, {
        description: 'Start time of the slot (ISO 8601)'
    })
});

export const zTimeSlotsResponse = z.object({
    payload: z.record(z.string(), z.array(zTimeSlot)).register(z.globalRegistry, {
        description: 'Available slots grouped by date'
    }),
    metadata: z.record(z.string(), z.unknown()).nullish().default(null)
});

export const zCatalogListMetadata = z.object({
    timestamp: z.string(),
    total: z.int(),
    count: z.int(),
    input_parameters: z.unknown().optional()
});

export const zCatalogListResponse = z.object({
    metadata: zCatalogListMetadata.optional(),
    payload: z.unknown().optional()
});

export const zTimeSlot1 = z.object({
    start: z.string().register(z.globalRegistry, {
        description: 'Start time of the slot (ISO 8601)'
    }),
    provider_id: z.string().nullish().default(null)
});

export const zTimeSlotsResponse1 = z.object({
    payload: z.record(z.string(), z.array(zTimeSlot1)).register(z.globalRegistry, {
        description: 'Available slots grouped by date'
    }),
    metadata: z.record(z.string(), z.unknown()).nullish().default(null)
});

export const zMultiFileUpload = z.object({
    files: z.array(z.string()).register(z.globalRegistry, {
        description: 'Multiple files to upload'
    })
});

export const zFileResults = z.object({
    metadata: zMetaData.optional(),
    payload: z.unknown().optional()
});

export const zAddress = z.object({
    street: z.string(),
    complement: z.string().nullish().default(null),
    city: z.string(),
    state: z.string(),
    zip_code: z.string()
});

export const zPatient = z.object({
    first_name: z.string(),
    last_name: z.string(),
    dob: z.iso.date(),
    phone_number: z.string().nullish(),
    email: z.string().nullish(),
    gender: z.enum([
        'Male',
        'Female',
        'Other'
    ]).optional(),
    address: zAddress
});

export const zInsurance2 = z.object({
    verification_key: z.uuid()
});

export const zContact = z.object({
    first_name: z.string(),
    last_name: z.string(),
    phone_number: z.string(),
    email: z.email(),
    relationship: z.enum([
        'Self',
        'Family Member',
        'Aide',
        'Coordinator',
        'Case Manager',
        'Health Proxy',
        'Other'
    ]),
    phone_type: z.enum([
        'Mobile',
        'Landline',
        'Office'
    ]),
    preferred_language: z.enum([
        'English',
        'Spanish',
        'Russian',
        'Chinese',
        'Arabic',
        'Other'
    ])
});

export const zCreateOrderInput = z.object({
    items: z.array(z.uuid()),
    patient: zPatient,
    insurances: z.array(zInsurance2).nullish().default(null),
    primary_contact: zContact,
    telehealth_provider_id: z.string(),
    telehealth_scheduled_time: z.iso.datetime(),
    telehealth_timezone: z.string().nullish().default(null),
    telehealth_contact_type: z.string().nullish().default(null),
    telehealth_appointment_type_id: z.string().nullish().default(null),
    insurance_gated: z.boolean().optional().default(false)
});

export const zAppointmentProvider1 = z.object({
    name: z.string(),
    phone_number: z.string()
});

export const zAppointment1 = z.object({
    scheduled_time: z.string(),
    timezone: z.string(),
    provider: zAppointmentProvider1
});

export const zOrderResponse1 = z.object({
    id: z.int(),
    appointment: zAppointment1.nullish(),
    tracking_url: z.string().nullish()
});

export const zCreateOrderResponse = z.object({
    metadata: z.record(z.string(), z.unknown()).optional(),
    payload: zOrderResponse1
});

export const zCreateOrderSimpleInput = z.object({
    items: z.array(z.uuid()),
    patient: zPatient,
    insurances: z.array(zInsurance2).nullish().default(null),
    primary_contact: zContact.nullish(),
    source_conversation_id: z.string().nullish()
});

export const zCarrierByState = z.object({
    uuid: z.string(),
    frhc_id: z.int(),
    state: z.string(),
    name: z.string(),
    display_name: z.string()
});

export const zCancelAppointmentRequest = z.object({
    order_public_id: z.string().register(z.globalRegistry, {
        description: 'Order public ID from the scheduling link'
    }),
    appointment_id: z.string().register(z.globalRegistry, {
        description: 'Healthie appointment ID to cancel'
    }),
    cancellation_reason: z.string().nullish().default(null),
    cancellation_reason_text: z.string().nullish().default(null)
});

export const zCancelAppointmentResponse = z.object({
    appointment_id: z.string().register(z.globalRegistry, {
        description: 'Healthie appointment ID that was cancelled'
    }),
    cancellation_reason: z.string().nullish().default(null),
    cancellation_reason_text: z.string().nullish().default(null),
    metadata: z.record(z.string(), z.unknown()).nullish().default(null)
});

export const zCreateCarrier = z.object({
    name: z.string().max(100),
    dme_template_uuid: z.uuid().nullish().default(null),
    percentage_modifier: z.int().nullish().default(null)
});

export const zCoverageZoneReconciliation = z.object({
    added: z.array(z.string()).register(z.globalRegistry, {
        description: 'Coverage zone UUIDs newly added'
    }).optional(),
    removed: z.array(z.string()).register(z.globalRegistry, {
        description: 'Coverage zone UUIDs removed'
    }).optional(),
    blocked: z.array(z.string()).register(z.globalRegistry, {
        description: 'Coverage zone UUIDs left in place (still referenced by a plan/product)'
    }).optional(),
    errors: z.array(z.string()).register(z.globalRegistry, {
        description: 'Coverage zone UUIDs that failed to update unexpectedly'
    }).optional()
});

export const zCarrierDetailMetadata = z.object({
    version: z.int().register(z.globalRegistry, {
        description: 'API version'
    }),
    timestamp: z.string().register(z.globalRegistry, {
        description: 'UTC timestamp'
    }),
    function_profile: z.record(z.string(), z.unknown()).nullish().default(null),
    coverage_zones: zCoverageZoneReconciliation.nullish()
});

export const zCarrierCoverageZoneRef = z.object({
    carrier_coverage_zone_uuid: z.string().register(z.globalRegistry, {
        description: 'Carrier coverage zone UUID (use as a plan\'s carrier_coverage_zone_uuid)'
    }),
    coverage_zone_uuid: z.string().register(z.globalRegistry, {
        description: 'Coverage zone (state) UUID'
    }),
    abbreviation: z.string().register(z.globalRegistry, {
        description: 'State abbreviation'
    })
});

export const zCarrierDetailPayload = z.object({
    uuid: z.string().register(z.globalRegistry, {
        description: 'Carrier UUID'
    }),
    name: z.string().register(z.globalRegistry, {
        description: 'Carrier name'
    }),
    is_template: z.boolean().register(z.globalRegistry, {
        description: 'Template carrier flag'
    }),
    is_active: z.boolean().register(z.globalRegistry, {
        description: 'Active flag'
    }),
    is_visible: z.boolean().register(z.globalRegistry, {
        description: 'Visible flag'
    }),
    status: z.string().nullish().default(null),
    status_uuid: z.string().nullish().default(null),
    dme_template_uuid: z.string().nullish().default(null),
    dme_template_name: z.string().nullish().default(null),
    percentage_modifier: z.int().nullish().default(null),
    frhc_id: z.int().nullish().default(null),
    plan_count: z.int().nullish().default(null),
    states: z.array(z.string()).register(z.globalRegistry, {
        description: 'State abbreviations the carrier covers'
    }).optional(),
    carrier_coverage_zones: z.array(zCarrierCoverageZoneRef).register(z.globalRegistry, {
        description: 'Carrier coverage zones (CCZ uuid + zone uuid + state) the carrier covers'
    }).optional(),
    created_at: z.string().nullish().default(null),
    modified_at: z.string().nullish().default(null)
});

export const zCarrierDetailResponse = z.object({
    metadata: zCarrierDetailMetadata,
    payload: zCarrierDetailPayload
});

export const zData = z.object({
    accountId: z.string().optional(),
    envelopeId: z.string().optional()
});

export const zEvent = z.object({
    event: z.string(),
    data: zData.nullish()
});

export const zCategoriesMetadata = z.object({
    timestamp: z.string().register(z.globalRegistry, {
        description: 'UTC timestamp'
    }),
    catalog: z.string().register(z.globalRegistry, {
        description: 'Catalog label used for filtering'
    })
});

export const zCategory2 = z.object({
    uuid: z.uuid(),
    label: z.string(),
    parent_uuid: z.uuid().nullish(),
    description: z.string().nullish(),
    image_url: z.string().nullish()
});

export const zCategoriesResponse = z.object({
    metadata: zCategoriesMetadata,
    payload: z.array(zCategory2)
});

export const zEscalateMcpOrderInput = z.object({
    message: z.string().register(z.globalRegistry, {
        description: 'The message to send to Slack'
    }),
    source_conversation_id: z.string().register(z.globalRegistry, {
        description: 'The Intercom conversation id'
    }),
    order_id: z.int().nullish(),
    failure_category: z.string().nullish()
});

export const zBookAppointmentRequest = z.object({
    order_public_id: z.string().register(z.globalRegistry, {
        description: 'Order public ID for the booking'
    }),
    patient_dob: z.string().register(z.globalRegistry, {
        description: 'Patient date of birth (YYYY-MM-DD) for re-verification'
    }),
    appointment_date: z.string().register(z.globalRegistry, {
        description: 'Selected appointment datetime (ISO 8601)'
    }),
    provider_id: z.string().register(z.globalRegistry, {
        description: 'Healthie provider user ID for the appointment'
    }),
    timezone: z.string().nullish().default('America/New_York'),
    telehealth_contact_type: z.string().nullish().default(null),
    appointment_type_id: z.string().nullish().default(null)
});

export const zBookAppointmentPayload = z.object({
    id: z.string().nullish().default(null),
    date: z.string().nullish().default(null),
    phone_number: z.string().nullish().default(null)
});

export const zBookAppointmentResponse = z.object({
    payload: zBookAppointmentPayload,
    metadata: z.record(z.string(), z.unknown()).nullish().default(null)
});

export const zGenerateLoMnInput = z.object({
    order_id: z.string(),
    file: z.string().nullish(),
    answered_requirements_json: z.string().optional().default('[]'),
    skip_checks: z.enum([
        'true',
        'false',
        'True',
        'False'
    ]).register(z.globalRegistry, {
        description: 'Whether to skip data sufficiency and correctness checks on the progress note. Use when note failed and you are now provided supplementary questionnaire answers to complete the requirements for the LoMN.'
    }).optional().default('false')
});

export const zDataCorrectness = z.object({
    key: z.string(),
    expected: z.string().nullish(),
    actual: z.string().nullish(),
    passes: z.boolean()
});

export const zAnswer = z.object({
    answer: z.string(),
    passes: z.boolean()
});

export const zAnalyzedRequirement = z.object({
    key: z.string(),
    description: z.string(),
    hcpcs: z.array(z.string()),
    question: z.string(),
    answers: z.array(zAnswer),
    passes: z.boolean(),
    reasoning: z.string(),
    evidence_quote: z.string().nullish()
});

export const zAnalyzedHcpc = z.object({
    hcpc: z.string(),
    requirements: z.array(zAnalyzedRequirement)
});

export const zRelatedIcd = z.object({
    code: z.string(),
    description: z.string()
});

export const zPerItemJustification = z.object({
    hcpc: z.string(),
    item_name: z.string(),
    requirement_keys: z.array(z.string()),
    related_icds: z.array(zRelatedIcd),
    justification: z.string()
});

export const zLetterOfMedicalNecessity = z.object({
    patient_complaint: z.string(),
    doctors_assessment: z.string(),
    per_item_justification: z.array(zPerItemJustification),
    overall_summary: z.string()
});

export const zLoMnDetails = z.object({
    uuid: z.string(),
    order_id: z.string(),
    created_at: z.iso.datetime(),
    progress_note_correctness: z.array(zDataCorrectness).optional(),
    progress_note_sufficiency: z.array(zAnalyzedHcpc).optional(),
    lomn: zLetterOfMedicalNecessity.optional(),
    error: z.record(z.string(), z.unknown()).optional()
});

export const zPagination1 = z.object({
    page: z.int().register(z.globalRegistry, {
        description: 'Current page'
    }),
    limit: z.int().register(z.globalRegistry, {
        description: 'Items per page'
    })
});

export const zOrganizationsMetadata = z.object({
    version: z.int().register(z.globalRegistry, {
        description: 'API version'
    }),
    timestamp: z.string().register(z.globalRegistry, {
        description: 'UTC timestamp'
    }),
    total: z.int().register(z.globalRegistry, {
        description: 'Total items'
    }),
    pagination: zPagination1
});

export const zOrganizationsResponse = z.object({
    metadata: zOrganizationsMetadata,
    payload: z.array(zOrganization).register(z.globalRegistry, {
        description: 'List of organizations'
    })
});

export const zCreatePlanCode = z.object({
    plan_uuid: z.uuid(),
    code: z.string().max(100)
});

export const zPlanCodeDetailMetadata = z.object({
    version: z.int().register(z.globalRegistry, {
        description: 'API version'
    }),
    timestamp: z.string().register(z.globalRegistry, {
        description: 'UTC timestamp'
    }),
    function_profile: z.record(z.string(), z.unknown()).nullish().default(null)
});

export const zPlanCodeDetailResponse = z.object({
    metadata: zPlanCodeDetailMetadata,
    payload: zPlanCodeResponse
});

export const zTrackingVerifyInput = z.object({
    last_name: z.string(),
    date_of_birth: z.iso.date()
});

export const zTrackingPatient = z.object({
    first_name: z.string().register(z.globalRegistry, {
        description: 'Patient first name'
    }),
    last_name: z.string().register(z.globalRegistry, {
        description: 'Patient last name'
    })
});

export const zTrackingContact = z.object({
    name: z.string().register(z.globalRegistry, {
        description: 'Display name'
    }),
    phone_number: z.string().nullish().default(null),
    email: z.string().nullish().default(null)
});

export const zTrackingShippingAddress = z.object({
    street: z.string().nullish().default(null),
    city: z.string().nullish().default(null),
    state: z.string().nullish().default(null),
    zip_code: z.string().nullish().default(null),
    complement: z.string().nullish().default(null)
});

export const zTrackingItem = z.object({
    title: z.string().nullish().default(null),
    description: z.string().nullish().default(null),
    quantity: z.int().nullish().default(null),
    image: z.string().nullish().default(null)
});

export const zTrackingTelehealth = z.object({
    kind: z.enum([
        'video',
        'phone',
        'unknown'
    ]).register(z.globalRegistry, {
        description: 'Visit kind: video, phone, or unknown'
    }),
    status: z.enum([
        'ok',
        'unavailable',
        'not_found'
    ]).register(z.globalRegistry, {
        description: 'Whether visit details were fetched successfully'
    }),
    scheduled_at: z.string().nullish().default(null),
    duration_minutes: z.int().nullish().default(null),
    provider_name: z.string().nullish().default(null),
    provider_phone_number: z.string().nullish().default(null),
    video_url: z.string().nullish().default(null)
});

export const zTrackingCancellation = z.object({
    cancelled_at: z.string().nullish().default(null),
    reason: z.string().nullish().default(null),
    description: z.string().nullish().default(null)
});

export const zTrackingShipping = z.object({
    shipped_at: z.string().nullish().default(null)
});

export const zTrackingDelivery = z.object({
    delivered_at: z.string().nullish().default(null)
});

export const zTrackingOrder = z.object({
    order_id: z.int().register(z.globalRegistry, {
        description: 'Standard integer order ID shown to patients'
    }),
    patient: zTrackingPatient,
    contact: zTrackingContact,
    shipping_address: zTrackingShippingAddress.nullish(),
    items: z.array(zTrackingItem).nullish().default(null),
    telehealth: zTrackingTelehealth.nullish(),
    has_televisit: z.boolean().register(z.globalRegistry, {
        description: 'Whether the order has a telehealth appointment on record'
    }).optional().default(false),
    created_at: z.string().nullish().default(null),
    placed_by: z.string().nullish().default(null),
    cancellation: zTrackingCancellation.nullish(),
    shipping: zTrackingShipping.nullish(),
    delivery: zTrackingDelivery.nullish()
});

export const zTrackingVerifyPayload = z.object({
    status: z.enum([
        'submitted',
        'upcoming_confirm',
        'televisit_upcoming',
        'televisit_needs_reschedule',
        'insurance_approval',
        'shipped',
        'delivered',
        'cancelled',
        'delayed',
        'error'
    ]).register(z.globalRegistry, {
        description: 'Patient-facing tracking status'
    }),
    is_resupply: z.boolean().register(z.globalRegistry, {
        description: 'Whether the order is a resupply'
    }),
    order: zTrackingOrder
});

export const zTrackingVerifyResponse = z.object({
    payload: zTrackingVerifyPayload,
    metadata: z.record(z.string(), z.unknown()).nullish().default(null)
});

export const zOrderReasonsResponse = z.object({
    metadata: z.record(z.string(), z.unknown()).optional(),
    payload: z.array(z.record(z.string(), z.unknown())).optional()
});

export const zOrderFilesMove = z.object({
    hash: z.string().register(z.globalRegistry, {
        description: 'Temporary hash folder'
    }),
    order_id: z.int().register(z.globalRegistry, {
        description: 'Order where to move the temp files'
    })
});

export const zIcd = z.object({
    code: z.string(),
    description: z.string()
});

export const zIcdSearchResponse = z.object({
    icds: z.array(zIcd),
    total: z.int()
});

export const zFeeScheduleMetaData = z.object({
    carrier: z.string().optional(),
    state: z.string().optional(),
    code: z.array(z.string()).optional(),
    duration: z.string(),
    function_profile: z.unknown().optional()
});

/**
 * Product Fee Schedule
 */
export const zFeeSchedule = z.object({
    uuid: z.uuid().optional(),
    carrier: z.string().optional(),
    coverage_zone: z.string().optional(),
    code: z.string().optional(),
    fee: z.number(),
    rental_fee: z.number(),
    max_refills: z.int(),
    max_units: z.int().nullish(),
    pa: z.int().nullish(),
    json_data: z.unknown().optional(),
    created_at: z.iso.datetime().nullish(),
    modified_at: z.iso.datetime().nullish(),
    is_visible: z.boolean().optional(),
    is_active: z.boolean().optional()
}).register(z.globalRegistry, {
    description: 'Product Fee Schedule'
});

export const zFeeScheduleResults = z.object({
    metadata: zFeeScheduleMetaData.optional(),
    payload: z.array(zFeeSchedule).optional()
});

export const zRescheduleAppointmentRequest = z.object({
    appointment_type_id: z.string().register(z.globalRegistry, {
        description: 'Healthie appointment type ID for the new appointment'
    }),
    appointment_date: z.string().register(z.globalRegistry, {
        description: 'New appointment datetime (ISO 8601)'
    }),
    provider_id: z.string().register(z.globalRegistry, {
        description: 'Healthie provider user ID for the new appointment'
    }),
    first: z.string().nullish().default(null),
    last: z.string().nullish().default(null),
    email: z.string().nullish().default(null),
    phone_number: z.string().nullish().default(null),
    appointment_id: z.string().nullish().default(null),
    contact_type: z.string().nullish().default(null)
});

export const zAppointmentProvider2 = z.object({
    id: z.string().nullish().default(null),
    full_name: z.string().nullish().default(null),
    phone_number: z.string().nullish().default(null)
});

export const zAppointmentType = z.object({
    id: z.string().nullish().default(null),
    name: z.string().nullish().default(null),
    length: z.int().nullish().default(null)
});

export const zRescheduleAppointmentPayload = z.object({
    id: z.string().nullish().default(null),
    date: z.string().nullish().default(null),
    contact_type: z.string().nullish().default(null),
    provider: zAppointmentProvider2.nullish(),
    appointment_type: zAppointmentType.nullish()
});

export const zRescheduleAppointmentResponse = z.object({
    payload: zRescheduleAppointmentPayload,
    metadata: z.record(z.string(), z.unknown()).nullish().default(null)
});

export const zPatientSearchResponse = z.object({
    metadata: z.record(z.string(), z.unknown()).optional(),
    payload: z.unknown().optional()
});

export const zUserDetailsResponse1 = z.object({
    metadata: zSearchMetaData,
    payload: zUserDetailsResponse
});

export const zUpdateUser = z.object({
    first_name: z.string().nullish().default(null),
    last_name: z.string().nullish().default(null),
    email: z.string().nullish().default(null),
    organization_id: z.int().nullish().default(null),
    phone_number: z.string().regex(/^\+[1-9]\d{1,14}$/).nullish().default(null),
    phone_number_extension: z.string().max(10).nullish().default(null),
    role: z.enum([
        'conduit_employee',
        'marketplace_user',
        'clinician',
        'supplier'
    ]).register(z.globalRegistry, {
        description: 'User Role'
    }).optional()
});

export const zUserResponse = z.object({
    user_id: z.string().register(z.globalRegistry, {
        description: 'Unique user identifier'
    }),
    first_name: z.string().register(z.globalRegistry, {
        description: 'User\'s first name'
    }),
    last_name: z.string().register(z.globalRegistry, {
        description: 'User\'s last name'
    }),
    email: z.string().register(z.globalRegistry, {
        description: 'User\'s email address'
    }),
    user_metadata: zUserMetadata.nullish(),
    app_metadata: zAppMetadata.nullish(),
    blocked: z.boolean().nullish().default(null),
    logins_count: z.int().nullish().default(null)
});

export const zUserResponseEnvelope = z.object({
    metadata: zSearchMetaData,
    payload: zUserResponse
});

export const zProperty1 = z.object({
    key: z.string(),
    display_text: z.string(),
    type: z.string(),
    required: z.boolean(),
    values: z.unknown().optional(),
    condition: z.string().nullish(),
    depends_on: z.string().nullish(),
    validation_type: z.string().nullish()
});

export const zVariant1 = z.object({
    key: z.string(),
    attributes: z.record(z.string(), z.unknown()).optional()
});

export const zCczSummary = z.object({
    uuid: z.uuid()
});

export const zCarrierSummary = z.object({
    uuid: z.uuid(),
    name: z.string()
});

export const zCoverageZoneSummary = z.object({
    uuid: z.uuid(),
    label: z.string(),
    abbreviation: z.string()
});

export const zCczpSummary = z.object({
    uuid: z.uuid(),
    version: z.int().optional(),
    is_active: z.boolean().optional(),
    is_visible: z.boolean().optional(),
    properties: z.array(zProperty1).optional(),
    variants: z.array(zVariant1).optional(),
    supplier_ids: z.array(z.int()).optional(),
    carrier_coverage_zone: zCczSummary.optional(),
    carrier: zCarrierSummary.optional(),
    coverage_zone: zCoverageZoneSummary.optional()
});

export const zProductDetails = z.object({
    uuid: z.uuid(),
    name: z.string(),
    description: z.string().nullish(),
    is_active: z.boolean(),
    is_visible: z.boolean(),
    status: z.string(),
    media: zMediaImage.nullish(),
    json_data: z.unknown().optional(),
    integrations: z.unknown().optional(),
    carrier_coverage_zone_products: z.array(zCczpSummary).optional(),
    categories: z.array(zCategory1)
});

export const zPlanListMetadata = z.object({
    version: z.int().register(z.globalRegistry, {
        description: 'API version'
    }),
    timestamp: z.string().register(z.globalRegistry, {
        description: 'UTC timestamp'
    }),
    total: z.int().register(z.globalRegistry, {
        description: 'Total matching records'
    }),
    count: z.int().register(z.globalRegistry, {
        description: 'Records returned'
    }),
    pagination: z.record(z.string(), z.unknown()).register(z.globalRegistry, {
        description: 'Pagination parameters'
    }),
    sorting: z.record(z.string(), z.unknown()).register(z.globalRegistry, {
        description: 'Sorting parameters'
    }),
    function_profile: z.record(z.string(), z.unknown()).nullish().default(null)
});

export const zPlanResponse = z.object({
    uuid: z.string().register(z.globalRegistry, {
        description: 'Plan UUID'
    }),
    carrier_coverage_zone_uuid: z.string().register(z.globalRegistry, {
        description: 'Carrier coverage zone UUID'
    }),
    plan_type: z.string().register(z.globalRegistry, {
        description: 'Plan type'
    }),
    name: z.string().register(z.globalRegistry, {
        description: 'Plan name'
    }),
    is_active: z.boolean().register(z.globalRegistry, {
        description: 'Active flag'
    }),
    is_visible: z.boolean().register(z.globalRegistry, {
        description: 'Visible flag'
    }),
    carrier_name: z.string().nullish().default(null),
    state: z.string().nullish().default(null),
    frhc_id: z.string().nullish().default(null),
    candid_payer_id: z.string().nullish().default(null),
    candid_que_payer_id: z.string().nullish().default(null),
    created_at: z.string().nullish().default(null),
    modified_at: z.string().nullish().default(null)
});

export const zPlanListResponse = z.object({
    metadata: zPlanListMetadata,
    payload: z.array(zPlanResponse).register(z.globalRegistry, {
        description: 'Matching plans'
    })
});

export const zGetAppointmentPayload = z.object({
    appointmentId: z.string().register(z.globalRegistry, {
        description: 'Healthie appointment ID'
    }),
    appointmentTypeId: z.string().nullish().default(null),
    appointmentDatetime: z.string().nullish().default(null),
    providerName: z.string().nullish().default(null)
});

export const zGetAppointmentResponse = z.object({
    payload: zGetAppointmentPayload,
    metadata: z.record(z.string(), z.unknown()).nullish().default(null)
});

export const zV1DbAdminTokenInput = z.object({
    token: z.string().optional(),
    options: z.record(z.string(), z.unknown()).optional().default({ verify_sig: true, verify_exp: true })
});

export const zV1DbAdminTokenResponse = z.object({
    app_metadata: z.record(z.string(), z.unknown()).optional(),
    user_metadata: z.record(z.string(), z.unknown()).optional(),
    user_info: z.record(z.string(), z.unknown()).optional()
});

export const zFulfillmentPayload = z.object({
    fulfillments: z.array(zFulfillment),
    missing: z.array(z.int())
});

export const zGetFulfillmentsResponse = z.object({
    metadata: z.record(z.string(), z.unknown()).optional(),
    payload: zFulfillmentPayload,
    errors: z.array(z.record(z.string(), z.unknown())).optional()
});

export const zMultiFilesUpload = z.object({
    files: z.array(z.string()).register(z.globalRegistry, {
        description: 'File to upload'
    })
});

export const zOrderDocumentsResponse = z.object({
    key: z.string().register(z.globalRegistry, {
        description: 'AWS file key'
    }),
    filename: z.string().register(z.globalRegistry, {
        description: 'Parsed file name'
    })
});

export const zOrderTmpDocumentsResponse = z.object({
    folder: z.string().register(z.globalRegistry, {
        description: 'Temporary folder name'
    }),
    files: z.array(zOrderDocumentsResponse).register(z.globalRegistry, {
        description: 'Temporary files'
    })
});

export const zUploadOrderTempDocumentsResponse = z.object({
    metadata: zBaseMetadata,
    payload: zOrderTmpDocumentsResponse
});

export const zBackfillRxDateInput = z.object({
    dry_run: z.boolean().nullish().default(false)
});

export const zHubSpotMetaData = z.object({
    timestamp: z.string().optional(),
    duration: z.string(),
    total: z.int(),
    count: z.int(),
    queries: z.unknown().optional(),
    function_profile: z.unknown().optional(),
    input_parameters: z.unknown().optional(),
    tasks: z.unknown().optional()
});

export const zHubSpotOrderedProduct = z.object({
    product_id: z.string().register(z.globalRegistry, {
        description: 'Unique identifier of the product'
    }),
    title: z.string().register(z.globalRegistry, {
        description: 'Product title'
    }),
    quantity: z.int().register(z.globalRegistry, {
        description: 'Quantity of the product in the order'
    })
});

export const zHubSpotShippingAddress = z.object({
    city: z.string().register(z.globalRegistry, {
        description: 'City name'
    }),
    complement: z.string().register(z.globalRegistry, {
        description: 'Apartment or unit info'
    }),
    created_at: z.iso.datetime().register(z.globalRegistry, {
        description: 'Timestamp when the address was created'
    }),
    state: z.string().register(z.globalRegistry, {
        description: 'Two-letter US state abbreviation'
    }),
    street: z.string().register(z.globalRegistry, {
        description: 'Street address'
    }),
    updated_at: z.iso.datetime().nullish(),
    zip_code: z.string().register(z.globalRegistry, {
        description: 'ZIP code'
    })
});

export const zHubSpotOrderResponse = z.object({
    id: z.int().register(z.globalRegistry, {
        description: 'Unique ID of the order'
    }),
    primary_insurance: z.string().register(z.globalRegistry, {
        description: 'Type of insurance used'
    }),
    patient_id: z.string().register(z.globalRegistry, {
        description: 'Unique identifier of the patient'
    }),
    primary_contact_id: z.string().register(z.globalRegistry, {
        description: 'Unique identifier of the primary contact'
    }),
    status: z.string().register(z.globalRegistry, {
        description: 'Current status of the order'
    }),
    supplier: z.string().register(z.globalRegistry, {
        description: 'Name of the supplier fulfilling the order'
    }),
    type: z.string().register(z.globalRegistry, {
        description: 'Order type'
    }),
    secondary_insurance: z.string().nullish(),
    parent_order: z.string().nullish().default(null),
    secondary_contact_id: z.string().nullish().default(null),
    referral_contact_id: z.string().nullish().default(null),
    hs_dealstage: z.string().nullish().default(null),
    created_at: z.iso.datetime().register(z.globalRegistry, {
        description: 'Timestamp when the order was created'
    }),
    last_status_change: z.iso.datetime().register(z.globalRegistry, {
        description: 'Timestamp of the last status change'
    }),
    modified_at: z.iso.datetime().register(z.globalRegistry, {
        description: 'Timestamp when the order was last updated'
    }),
    products: z.array(zHubSpotOrderedProduct).register(z.globalRegistry, {
        description: 'List of items included in the order'
    }),
    shipping_address: zHubSpotShippingAddress,
    is_resupply: z.boolean().nullish().default(false)
});

export const zHubSpotOrderResults = z.object({
    metadata: zHubSpotMetaData.optional(),
    payload: z.array(zHubSpotOrderResponse).optional()
});

export const zHubSpotOrderInput = z.object({
    hubspot_id: z.string()
});

export const zParentCategory = z.object({
    uuid: z.uuid(),
    label: z.string()
});

export const zProductCategory1 = z.object({
    uuid: z.uuid(),
    label: z.string(),
    parent: zParentCategory.nullish()
});

export const zCoverageZone = z.object({
    uuid: z.string(),
    label: z.string(),
    abbreviation: z.string().optional()
});

export const zConversionEventRequest = z.object({
    event_name: z.enum(['Schedule', 'CompleteRegistration']),
    email: z.string(),
    phone_number: z.string(),
    first_name: z.string().nullish().default(null),
    last_name: z.string().nullish().default(null),
    gclid: z.string().nullish().default(null)
});

export const zCoverageZoneListMetadata = z.object({
    version: z.int().register(z.globalRegistry, {
        description: 'API version'
    }),
    timestamp: z.string().register(z.globalRegistry, {
        description: 'UTC timestamp'
    }),
    total: z.int().register(z.globalRegistry, {
        description: 'Total matching records'
    }),
    count: z.int().register(z.globalRegistry, {
        description: 'Records returned'
    }),
    function_profile: z.record(z.string(), z.unknown()).nullish().default(null)
});

export const zCoverageZoneResponse = z.object({
    uuid: z.string().register(z.globalRegistry, {
        description: 'Coverage zone UUID'
    }),
    label: z.string().register(z.globalRegistry, {
        description: 'Coverage zone label'
    }),
    abbreviation: z.string().register(z.globalRegistry, {
        description: 'State abbreviation'
    })
});

export const zCoverageZoneListResponse = z.object({
    metadata: zCoverageZoneListMetadata,
    payload: z.array(zCoverageZoneResponse).register(z.globalRegistry, {
        description: 'Coverage zones'
    })
});

export const zFlatCatalogMetadata = z.object({
    timestamp: z.string().register(z.globalRegistry, {
        description: 'UTC timestamp'
    }),
    catalog: z.string().nullish().default(null)
});

export const zFlatCatalogRow = z.object({
    catalog: z.string().register(z.globalRegistry, {
        description: 'Catalog label'
    }),
    category: z.string().nullish().default(null),
    bundle_name: z.string().register(z.globalRegistry, {
        description: 'Parent bundle name, or product name if standalone'
    }),
    product_name: z.string().register(z.globalRegistry, {
        description: 'Product name'
    }),
    product_description: z.string().nullish().default(null),
    hcpc: z.string().register(z.globalRegistry, {
        description: 'HCPC code label'
    })
});

export const zFlatCatalogResponse = z.object({
    metadata: zFlatCatalogMetadata,
    payload: z.array(zFlatCatalogRow).register(z.globalRegistry, {
        description: 'Flat list of product × HCPC rows'
    })
});

export const zCoverageZonesMetadata = z.object({
    timestamp: z.string(),
    catalog: z.string().nullish()
});

export const zCoverageZone1 = z.object({
    uuid: z.uuid(),
    label: z.string(),
    abbreviation: z.string()
});

export const zCoverageZonesResponse = z.object({
    metadata: zCoverageZonesMetadata,
    payload: z.array(zCoverageZone1)
});

export const zTimeSlotReservationRequest = z.object({
    start: z.iso.datetime().register(z.globalRegistry, {
        description: 'Start datetime of the slot to reserve (ISO 8601)'
    })
});

export const zTimeSlotReservation = z.object({
    slot_start: z.string().register(z.globalRegistry, {
        description: 'Start time of the reserved slot'
    }),
    slot_end: z.string().register(z.globalRegistry, {
        description: 'End time of the reserved slot'
    }),
    slot_duration: z.int().register(z.globalRegistry, {
        description: 'Duration of the slot in minutes'
    }),
    reservation_uid: z.uuid().register(z.globalRegistry, {
        description: 'Unique identifier for the reservation'
    }),
    reservation_duration: z.int().register(z.globalRegistry, {
        description: 'How long the reservation is held in minutes'
    }),
    reservation_until: z.string().register(z.globalRegistry, {
        description: 'Datetime until which the reservation is valid'
    })
});

export const zTimeSlotReservationResponse = z.object({
    payload: zTimeSlotReservation,
    metadata: z.record(z.string(), z.unknown()).nullish().default(null)
});

export const zHubSpotProduct = z.object({
    id: z.string().register(z.globalRegistry, {
        description: 'Unique identifier for the product'
    }),
    title: z.string().register(z.globalRegistry, {
        description: 'Name of the product'
    }),
    description: z.string().register(z.globalRegistry, {
        description: 'Detailed description of the product'
    }),
    categories: z.array(z.string()).register(z.globalRegistry, {
        description: 'List of product category labels'
    }),
    show_on_catalog: z.boolean().register(z.globalRegistry, {
        description: 'Flag to indicate whether the product should appear in the catalog'
    }),
    active: z.boolean().register(z.globalRegistry, {
        description: 'Indicates if the product is active and available'
    })
});

export const zHubSpotProductResults = z.object({
    metadata: zHubSpotMetaData.optional(),
    payload: z.array(zHubSpotProduct).optional()
});

export const zHubSpotContact = z.object({
    id: z.string().nullish().default(null),
    raw_id: z.string().nullish().default(null),
    contact_type: z.string().nullish().default(null),
    date_of_birth: z.iso.date().nullish().default(null),
    email: z.string().nullish().default(null),
    first_name: z.string().nullish().default(null),
    gender: z.string().nullish().default(null),
    last_name: z.string().nullish().default(null),
    phone_number: z.string().nullish().default(null),
    phone_type: z.string().nullish().default(null),
    preferred_language: z.string().nullish().default(null)
});

export const zHubSpotContactResults = z.object({
    metadata: zHubSpotMetaData.optional(),
    payload: z.array(zHubSpotContact).optional()
});

export const zHubSpotContactInput = z.object({
    hubspot_id: z.string()
});

export const zPatientDetailResponse = z.object({
    metadata: zSearchMetaData1,
    payload: zPatientResponse
});

export const zCarrierListMetadata = z.object({
    version: z.int().register(z.globalRegistry, {
        description: 'API version'
    }),
    timestamp: z.string().register(z.globalRegistry, {
        description: 'UTC timestamp'
    }),
    total: z.int().register(z.globalRegistry, {
        description: 'Total matching records'
    }),
    count: z.int().register(z.globalRegistry, {
        description: 'Records returned'
    }),
    pagination: z.record(z.string(), z.unknown()).register(z.globalRegistry, {
        description: 'Pagination parameters'
    }),
    sorting: z.record(z.string(), z.unknown()).register(z.globalRegistry, {
        description: 'Sorting parameters'
    }),
    function_profile: z.record(z.string(), z.unknown()).nullish().default(null)
});

export const zCarrierResponse = z.object({
    uuid: z.string().register(z.globalRegistry, {
        description: 'Carrier UUID'
    }),
    name: z.string().register(z.globalRegistry, {
        description: 'Carrier name'
    }),
    is_template: z.boolean().register(z.globalRegistry, {
        description: 'Template carrier flag'
    }),
    is_active: z.boolean().register(z.globalRegistry, {
        description: 'Active flag'
    }),
    is_visible: z.boolean().register(z.globalRegistry, {
        description: 'Visible flag'
    }),
    status: z.string().nullish().default(null),
    status_uuid: z.string().nullish().default(null),
    dme_template_uuid: z.string().nullish().default(null),
    dme_template_name: z.string().nullish().default(null),
    percentage_modifier: z.int().nullish().default(null),
    frhc_id: z.int().nullish().default(null),
    plan_count: z.int().nullish().default(null),
    states: z.array(z.string()).register(z.globalRegistry, {
        description: 'State abbreviations the carrier covers'
    }).optional(),
    carrier_coverage_zones: z.array(zCarrierCoverageZoneRef).register(z.globalRegistry, {
        description: 'Carrier coverage zones (CCZ uuid + zone uuid + state) the carrier covers'
    }).optional(),
    created_at: z.string().nullish().default(null),
    modified_at: z.string().nullish().default(null)
});

export const zCarrierListResponse = z.object({
    metadata: zCarrierListMetadata,
    payload: z.array(zCarrierResponse).register(z.globalRegistry, {
        description: 'Matching carriers'
    })
});

export const zRequestEsignature = z.object({
    file: z.string().register(z.globalRegistry, {
        description: 'File to upload'
    }),
    on_screen: z.boolean().nullish().default(false)
});

export const zEsignatureResponse = z.object({
    payload: z.record(z.string(), z.unknown()),
    metadata: z.record(z.string(), z.unknown()).nullish().default(null)
});

export const zOrderTransitionMetadata = z.object({
    version: z.int().register(z.globalRegistry, {
        description: 'API version'
    }),
    timestamp: z.string().register(z.globalRegistry, {
        description: 'UTC timestamp'
    })
});

export const zOrderTransitionPayload = z.object({
    id: z.int().register(z.globalRegistry, {
        description: 'Order ID'
    }),
    status: z.string().register(z.globalRegistry, {
        description: 'Current order status'
    })
});

export const zOrderTransitionResponse = z.object({
    metadata: zOrderTransitionMetadata,
    payload: zOrderTransitionPayload
});

export const zNpiAddressResponse = z.object({
    payload: z.array(z.lazy((): any => zNpiAddressResponse)).register(z.globalRegistry, {
        description: 'Physician addresses'
    }),
    metadata: zBaseMetadata.nullish()
});

export const zInsuranceCardUploadUrlRequest = z.object({
    verification_key: z.string(),
    side: z.enum(['front', 'back']),
    content_type: z.enum([
        'image/jpeg',
        'image/png',
        'image/heic',
        'application/pdf'
    ])
});

export const zInsuranceCardUploadUrlResponse = z.object({
    verification_key: z.string(),
    s3_object_key: z.string(),
    presigned_put_url: z.string(),
    expires_in_seconds: z.int()
});

export const zCarrierStatusListMetadata = z.object({
    version: z.int().register(z.globalRegistry, {
        description: 'API version'
    }),
    timestamp: z.string().register(z.globalRegistry, {
        description: 'UTC timestamp'
    }),
    total: z.int().register(z.globalRegistry, {
        description: 'Total matching records'
    }),
    count: z.int().register(z.globalRegistry, {
        description: 'Records returned'
    }),
    function_profile: z.record(z.string(), z.unknown()).nullish().default(null)
});

export const zCarrierStatusResponse = z.object({
    uuid: z.string().register(z.globalRegistry, {
        description: 'Carrier status UUID'
    }),
    label: z.string().register(z.globalRegistry, {
        description: 'Carrier status label'
    }),
    order: z.int().register(z.globalRegistry, {
        description: 'Display order'
    })
});

export const zCarrierStatusListResponse = z.object({
    metadata: zCarrierStatusListMetadata,
    payload: z.array(zCarrierStatusResponse).register(z.globalRegistry, {
        description: 'Carrier statuses'
    })
});

export const zVerifyPatientBookingRequest = z.object({
    order_public_id: z.string().register(z.globalRegistry, {
        description: 'Order public ID from the scheduling link'
    }),
    patient_dob: z.string().register(z.globalRegistry, {
        description: 'Patient date of birth (YYYY-MM-DD) for identity verification'
    })
});

export const zVerifyPatientBookingPayload = z.object({
    patient_state: z.string().nullish().default(null)
});

export const zVerifyPatientBookingResponse = z.object({
    payload: zVerifyPatientBookingPayload,
    metadata: z.record(z.string(), z.unknown()).nullish().default(null)
});

/**
 * Carrier Code Categories
 */
export const zCodeCategory = z.object({
    status: z.string().optional(),
    state: z.string().optional(),
    label: z.string().max(255),
    description: z.string().nullish(),
    json_data: z.unknown().optional(),
    created_at: z.iso.datetime().nullish(),
    modified_at: z.iso.datetime().nullish(),
    uuid: z.uuid().optional(),
    is_visible: z.boolean().optional(),
    is_active: z.boolean().optional()
}).register(z.globalRegistry, {
    description: 'Carrier Code Categories'
});

export const zMetaData1 = z.object({
    input_parameters: z.record(z.string(), z.unknown()),
    function_profile: z.unknown(),
    timestamp: z.string().nullish().default(null)
});

export const zEpacesEligibility = z.object({
    link: z.string(),
    member_id: z.string(),
    name: z.string(),
    date_submitted: z.string().nullish().default(null),
    details: z.record(z.string(), z.unknown()).nullish().default(null)
});

export const zEpacesEligibilityResponse = z.object({
    meta_data: zMetaData1,
    payload: z.array(zEpacesEligibility)
});

export const zSlackPostInput = z.object({
    channel: z.string(),
    message: z.string()
});

export const zEditProductInput = z.object({
    name: z.string().nullish(),
    description: z.string().nullish(),
    status_uuid: z.uuid().nullish(),
    category_uuid: z.uuid().nullish(),
    media: zMediaImage.nullish()
});

export const zPlanCodeListMetadata = z.object({
    version: z.int().register(z.globalRegistry, {
        description: 'API version'
    }),
    timestamp: z.string().register(z.globalRegistry, {
        description: 'UTC timestamp'
    }),
    total: z.int().register(z.globalRegistry, {
        description: 'Total matching records'
    }),
    count: z.int().register(z.globalRegistry, {
        description: 'Records returned'
    }),
    pagination: z.record(z.string(), z.unknown()).register(z.globalRegistry, {
        description: 'Pagination parameters'
    }),
    sorting: z.record(z.string(), z.unknown()).register(z.globalRegistry, {
        description: 'Sorting parameters'
    }),
    function_profile: z.record(z.string(), z.unknown()).nullish().default(null)
});

export const zPlanCodeListResponse = z.object({
    metadata: zPlanCodeListMetadata,
    payload: z.array(zPlanCodeResponse).register(z.globalRegistry, {
        description: 'Matching plan codes'
    })
});

export const zOrderTransitionResponse1 = z.object({
    metadata: z.record(z.string(), z.unknown()).optional(),
    payload: z.unknown().optional()
});

export const zRejectOrderInput = z.object({
    reason: z.string(),
    description: z.string().nullish().default(null)
});

export const zAnalyzeProgressNoteInput = z.object({
    order_id: z.string(),
    file: z.string().register(z.globalRegistry, {
        description: 'File to upload'
    })
});

export const zOldDataCorrectness = z.object({
    key: z.string(),
    expected: z.string(),
    actual: z.string().nullish(),
    is_match: z.boolean()
});

export const zOldAnalyzedRequirement = z.object({
    key: z.string(),
    description: z.string(),
    reasoning: z.string(),
    is_met: z.boolean(),
    evidence_quote: z.string().nullish()
});

export const zOldAnalyzedHcpc = z.object({
    hcpc: z.string(),
    requirements: z.array(zOldAnalyzedRequirement).min(1)
});

export const zAnalyzedProgressNotePayload = z.object({
    order_id: z.string(),
    correctness: z.array(zOldDataCorrectness),
    sufficiency: z.array(zOldAnalyzedHcpc)
});

export const zAnalyzeProgressNoteResponse = z.object({
    metadata: zMetaData.optional(),
    payload: zAnalyzedProgressNotePayload
});

export const zIntercomReplyInput = z.object({
    conversation_id: z.string().regex(/^\d+$/),
    body: z.string()
});

export const zSyncMongoOrdersByIdRequest = z.object({
    mongo_order_ids: z.array(z.int())
});

export const zReassignPatientBody = z.object({
    user_id: z.string().register(z.globalRegistry, {
        description: 'Auth0 user ID to reassign the patient to'
    })
});

export const zReassignPatientPayload = z.object({
    patient_id: z.int().register(z.globalRegistry, {
        description: 'Patient ID'
    }),
    user_id: z.string().register(z.globalRegistry, {
        description: 'New Auth0 user ID'
    }),
    organization_id: z.int().register(z.globalRegistry, {
        description: 'New organization ID'
    })
});

export const zReassignPatientResponse = z.object({
    metadata: zSearchMetaData1,
    payload: zReassignPatientPayload
});

export const zAdminProductCategory = z.object({
    uuid: z.uuid(),
    label: z.string(),
    parent_category: z.unknown().optional()
});

export const zAdminProductDetails = z.object({
    uuid: z.uuid(),
    name: z.string(),
    description: z.string().nullish(),
    is_active: z.boolean(),
    is_visible: z.boolean(),
    status: z.string().nullish(),
    media: z.unknown().optional(),
    json_data: z.unknown().optional(),
    integrations: z.unknown().optional(),
    categories: z.array(zAdminProductCategory).optional(),
    configurations: z.unknown().optional()
});

export const zCreateOrderResponse1 = z.object({
    metadata: z.record(z.string(), z.unknown()).optional(),
    payload: z.unknown().optional()
});

export const zOrderFilesResponse = z.object({
    metadata: zBaseMetadata,
    payload: z.array(zOrderDocumentsResponse).nullish().default(null)
});

export const zEmptyResponse = z.record(z.string(), z.unknown());

export const zOrderItemCategoriesResponse = z.object({
    primary: z.string().nullish().default(null),
    secondary: z.string().nullish().default(null)
});

export const zOrderItemResponse = z.object({
    id: z.string().nullish().default(null),
    title: z.string().nullish().default(null),
    categories: zOrderItemCategoriesResponse.nullish()
});

export const zOrderResponse2 = z.object({
    id: z.int().nullish().default(null),
    status: z.string().nullish().default(null),
    created_at: z.string().nullish().default(null),
    delivery_date: z.string().nullish().default(null),
    items: z.array(zOrderItemResponse).nullish().default(null)
});

export const zPatientOrdersResponse = z.object({
    metadata: zSearchMetaData1,
    payload: z.array(zOrderResponse2).register(z.globalRegistry, {
        description: 'List of orders'
    })
});

export const zRefreshEsignature = z.object({
    envelope_id: z.string().register(z.globalRegistry, {
        description: 'Envelope e-signature id'
    })
});

export const zCarrierSchemaV3 = z.object({
    uuid: z.string(),
    state: z.string(),
    name: z.string(),
    display_name: z.string(),
    carrier_types: z.array(z.enum([
        'private',
        'medicaid',
        'medicare'
    ])),
    template_uuid: z.string().nullable(),
    is_other: z.boolean()
});

export const zPatientContactsResponse = z.object({
    metadata: zSearchMetaData1,
    payload: z.array(zContactResponse).register(z.globalRegistry, {
        description: 'List of contacts'
    })
});

export const zUpdatePlan = z.object({
    carrier_coverage_zone_uuid: z.uuid().nullish().default(null),
    plan_type: z.enum([
        'medicare',
        'medicare_advantage',
        'medicaid',
        'medicaid_managed_care'
    ]).optional(),
    name: z.string().max(100).nullish().default(null),
    frhc_id: z.string().max(50).nullish().default(null),
    candid_payer_id: z.string().max(50).nullish().default(null),
    candid_que_payer_id: z.string().max(50).nullish().default(null),
    is_active: z.boolean().nullish().default(null),
    is_visible: z.boolean().nullish().default(null)
});

export const zMessage = z.object({
    headers: z.record(z.string(), z.unknown()).optional(),
    key: z.string().optional(),
    data: z.record(z.string(), z.unknown()).optional()
});

export const zEpacesPriorAuthorizationExtendedData = z.object({
    determination: z.string(),
    effective_daterange: z.string(),
    extended_link: z.string(),
    extended_query_params: z.record(z.string(), z.unknown()),
    fee: z.number(),
    hcpc: z.string(),
    issue_date: z.string(),
    line: z.int(),
    more_details: z.string(),
    reason: z.string(),
    units: z.int(),
    service_date: z.record(z.string(), z.unknown()),
    url: z.string()
});

export const zEpacesPriorAuthorization = z.object({
    row_number: z.int(),
    member_id: z.string(),
    action: z.string(),
    cert_type: z.string(),
    service_type: z.string(),
    date_sent: z.string(),
    name: z.record(z.string(), z.unknown()),
    client_id_link: z.string(),
    client_id_link_params: z.record(z.string(), z.unknown()),
    image_upload: z.string(),
    response_descriptive_text: z.string(),
    review_id_number: z.string(),
    url: z.string(),
    extended_data: zEpacesPriorAuthorizationExtendedData.nullish()
});

export const zEpacesPriorAuthorizationResponse = z.object({
    meta_data: zMetaData1,
    payload: z.array(zEpacesPriorAuthorization)
});

export const zUpdateOrganization = z.object({
    name: z.string().max(100).optional(),
    phone_number: z.string().max(20).optional(),
    phone_number_extension: z.string().max(10).optional(),
    is_active: z.boolean().optional(),
    address: zCreateOrganizationAddress.optional()
});

export const zPatientAddressesResponse = z.object({
    metadata: zSearchMetaData1,
    payload: z.array(zAddressResponse).register(z.globalRegistry, {
        description: 'List of addresses'
    })
});

export const zUpdateContactInput = z.object({
    type: z.enum(['primary_contact', 'secondary_contact']).optional(),
    contact: zContactInput.optional()
});

export const zUpdateOrderContactResponse = z.object({
    metadata: z.record(z.string(), z.unknown()).optional(),
    payload: z.unknown().optional()
});

export const zUpdateOrderPatientResponse = z.object({
    metadata: z.record(z.string(), z.unknown()).optional(),
    payload: z.unknown().optional()
});

export const zPrescriptionMetadataInput = z.object({
    expiration_date: z.iso.datetime().register(z.globalRegistry, {
        description: 'ISO 8601 datetime for the prescription expiration date'
    }),
    reference: z.string().nullish().default(null)
});

export const zRxDateUpdateResponse = z.object({
    signing_date: z.string().nullish().default(null),
    expiration_date: z.string().nullish().default(null),
    source: z.string().nullish().default(null),
    reference: z.string().nullish().default(null)
});

export const zPatientInsurancesResponse = z.object({
    metadata: zSearchMetaData1,
    payload: z.array(zInsuranceResponse).register(z.globalRegistry, {
        description: 'List of insurances'
    })
});

export const zCodeEligibilityOverride = z.object({
    uuid: z.string(),
    override: z.string(),
    notes: z.string().nullish().default(null),
    code_uuid: z.string().nullish().default(null),
    plan_type: z.string().nullish().default(null),
    plan_uuid: z.string().nullish().default(null),
    plan_code_uuid: z.string().nullish().default(null),
    created_at: z.string().nullish().default(null),
    modified_at: z.string().nullish().default(null)
});

export const zCodeEligibilityOverrideList = z.object({
    payload: z.array(zCodeEligibilityOverride),
    metadata: z.record(z.string(), z.unknown()).nullish().default(null)
});

export const zCreateCodeEligibilityOverrideInput = z.object({
    override: z.string(),
    notes: z.string().nullish().default(null),
    code_uuid: z.string().nullish().default(null),
    plan_type: z.string().nullish().default(null),
    plan_uuid: z.string().nullish().default(null),
    plan_code_uuid: z.string().nullish().default(null)
});

export const zCodeEligibilityOverrideResponse = z.object({
    payload: zCodeEligibilityOverride,
    metadata: z.record(z.string(), z.unknown()).nullish().default(null)
});

export const zSupplierInput = z.object({
    legacy_supplier_id: z.int()
});

export const zUpdateOrderSupplierResponse = z.object({
    metadata: z.record(z.string(), z.unknown()).optional(),
    payload: z.unknown().optional()
});

export const zAssigneeInput = z.object({
    assignee_id: z.string().nullable()
});

export const zUpdateAssigneeResponse = z.object({
    metadata: z.record(z.string(), z.unknown()).optional(),
    payload: z.unknown().optional()
});

export const zUpdateReferralInput = z.object({
    first_name: z.string(),
    last_name: z.string(),
    phone_number: z.string().nullish(),
    email: z.email().nullish()
});

export const zUpdateOrderReferralResponse = z.object({
    metadata: z.record(z.string(), z.unknown()).optional(),
    payload: z.unknown().optional()
});

export const zChangeInput = z.object({
    reason: z.string(),
    description: z.string().nullish().default(null)
});

export const zRequestChangesInput = z.object({
    changes: z.array(zChangeInput)
});

export const zInsuranceCardDownloadPayload = z.object({
    key: z.string().register(z.globalRegistry, {
        description: 'The s3:// URI requested (echoed back as cache key)'
    }),
    url: z.string().register(z.globalRegistry, {
        description: 'Presigned S3 GET URL for the card image'
    }),
    expires_at: z.string().register(z.globalRegistry, {
        description: 'ISO 8601 UTC timestamp at which the presigned URL becomes stale. Clients may reuse the URL until this time; after it they must re-request.'
    })
});

export const zInsuranceCardDownloadResponse = z.object({
    metadata: zBaseMetadata,
    payload: zInsuranceCardDownloadPayload
});

export const zAiConversationDetails = z.object({
    uuid: z.string(),
    table_name: z.string(),
    record_uuid: z.string(),
    ai_session_uuid: z.string(),
    status: z.string(),
    model: z.string(),
    service: z.string(),
    request: z.record(z.string(), z.unknown()),
    response: z.record(z.string(), z.unknown()),
    json_data: z.record(z.string(), z.unknown())
});

export const zLoMnHistoryResponse = z.object({
    order_id: z.string(),
    lomn_generations: z.array(zLoMnDetails),
    ai_conversations: z.array(zAiConversationDetails)
});

export const zNetworkStatusDesignation = z.object({
    uuid: z.string(),
    service_line: z.string(),
    status: z.string(),
    plan_type: z.string().nullish().default(null),
    plan_uuid: z.string().nullish().default(null),
    plan_code_uuid: z.string().nullish().default(null),
    created_at: z.string().nullish().default(null),
    modified_at: z.string().nullish().default(null)
});

export const zNetworkStatusDesignationList = z.object({
    payload: z.array(zNetworkStatusDesignation),
    metadata: z.record(z.string(), z.unknown()).nullish().default(null)
});

export const zCreateNetworkStatusDesignationInput = z.object({
    service_line: z.string(),
    status: z.string(),
    plan_type: z.string().nullish().default(null),
    plan_uuid: z.string().nullish().default(null),
    plan_code_uuid: z.string().nullish().default(null)
});

export const zNetworkStatusDesignationResponse = z.object({
    payload: zNetworkStatusDesignation,
    metadata: z.record(z.string(), z.unknown()).nullish().default(null)
});

export const zUpdatePhysicianInput = z.object({
    first_name: z.string(),
    last_name: z.string(),
    npi: z.string(),
    phone: z.string().nullish(),
    email: z.email().nullish(),
    address: zAddressInput.nullish(),
    patient_last_visit: z.iso.date().nullish()
});

export const zUpdateOrderPhysicianResponse = z.object({
    metadata: z.record(z.string(), z.unknown()).optional(),
    payload: z.unknown().optional()
});

export const zUpdateInsuranceInput = z.object({
    type: z.enum(['insurance', 'secondary_insurance']),
    insurance: zInsuranceInput
});

export const zUpdateOrderInsuranceResponse = z.object({
    metadata: z.record(z.string(), z.unknown()).optional(),
    payload: z.unknown().optional()
});

export const zOrderFileUpload = z.object({
    file: z.string().register(z.globalRegistry, {
        description: 'File to upload'
    }),
    filename: z.string().nullish().default(null)
});

export const zUploadOrderDocumentsResponse = z.object({
    metadata: zBaseMetadata,
    payload: zOrderDocumentsResponse
});

export const zSupplierDetailMetaData = z.object({
    timestamp: z.string().register(z.globalRegistry, {
        description: 'UTC timestamp'
    }),
    function_profile: z.record(z.string(), z.unknown()).nullish().default(null)
});

export const zSupplierDetailResponse = z.object({
    metadata: zSupplierDetailMetaData,
    payload: zSupplierResponse
});

export const zUpdateCarrier = z.object({
    name: z.string().max(100).optional(),
    dme_template_uuid: z.uuid().nullish(),
    percentage_modifier: z.int().nullish(),
    status_uuid: z.uuid().optional(),
    is_template: z.boolean().optional(),
    is_active: z.boolean().optional(),
    is_visible: z.boolean().optional(),
    coverage_zone_uuids: z.array(z.uuid()).optional()
});

export const zCatalogProductResponse = z.object({
    metadata: z.unknown().optional(),
    payload: z.unknown().optional()
});

export const zIcdResponse = z.object({
    icds: z.array(zIcd)
});

export const zRequestEsignatureInput = z.object({
    file: z.string().register(z.globalRegistry, {
        description: 'PDF file to be signed'
    }),
    on_screen: z.boolean().optional().default(false)
});

export const zOrderOperationResponse = z.object({
    status: z.string(),
    order_id: z.int()
});

export const zPerson = z.object({
    first_name: z.string(),
    last_name: z.string(),
    date_of_birth: z.string().register(z.globalRegistry, {
        description: 'Date of birth in YYYY-MM-DD format'
    }),
    gender: z.string().nullish(),
    mrn: z.string().nullish(),
    ssn: z.string().nullish(),
    address_line1: z.string().nullish(),
    address_line2: z.string().nullish(),
    city: z.string().nullish(),
    state: z.string().nullish(),
    zip: z.string().nullish()
});

export const zFrontRunnerMetaData = z.object({
    timestamp: z.string().optional(),
    duration: z.string(),
    total: z.int(),
    count: z.int(),
    queries: z.unknown().optional(),
    function_profile: z.unknown().optional(),
    input_parameters: z.unknown().optional()
});

export const zDemographicInformation = z.object({
    active_military_duty_fraud_alert: z.string().nullish(),
    address: z.string().nullish(),
    address_action_code: z.string().nullish(),
    charity_status: z.string().nullish(),
    city: z.string().nullish(),
    deceased_date: z.string().nullish(),
    dob: z.string().nullish(),
    dob_action_code: z.string().nullish(),
    estimated_household_income: z.int().nullish(),
    estimated_household_size: z.int().nullish(),
    federal_poverty_level_percent: z.int().nullish(),
    first_name: z.string().nullish(),
    gender: z.string().nullish(),
    last_name: z.string().nullish(),
    medicaid_status: z.string().nullish(),
    middle_name: z.string().nullish(),
    name_action_code: z.string().nullish(),
    payment_advisor_category: z.string().nullish(),
    payment_advisor_category_name: z.string().nullish(),
    payment_advisor_score: z.int().nullish(),
    payment_advisor_suggestion: z.string().nullish(),
    phone: z.string().nullish(),
    possible_phone_numbers: z.array(z.string()).nullish(),
    red_flag_action_code: z.string().nullish(),
    ssn: z.string().nullish(),
    ssn_action_code: z.string().nullish(),
    state: z.string().nullish(),
    total_avail_credit: z.number().nullish(),
    treatment_assignment: z.string().nullish(),
    zip: z.string().nullish(),
    accuracy_color: z.string().nullish(),
    accuracy: z.string().nullish(),
    risk_indicator: z.string().nullish(),
    red_flag: z.string().nullish(),
    credit_score: z.int().nullish(),
    frhc_risk_indicator: z.string().nullish()
});

export const zAdditionalCoverage = z.object({
    certificate_number: z.string().nullish(),
    effective_date: z.string().nullish(),
    eligibility_information: z.string().nullish(),
    entity_identifier: z.string().nullish(),
    insurance_type: z.string().nullish(),
    message: z.string().nullish(),
    payor_id: z.string().nullish(),
    plan_description: z.string().nullish(),
    plan_name: z.string().nullish(),
    service_types: z.array(z.string()).nullish(),
    termination_date: z.string().nullish(),
    type_eb03: z.string().nullish(),
    type_nm101: z.string().nullish(),
    plan_code: z.string().nullish().default('')
});

export const zEligibilityCost = z.object({
    deductible: z.number().nullish(),
    deductible_remaining: z.number().nullish(),
    out_of_pocket_max: z.number().nullish(),
    out_of_pocket_remaining: z.number().nullish(),
    out_of_network_deductible: z.number().nullish(),
    out_of_network_deductible_remaining: z.number().nullish(),
    out_of_network_out_of_pocket_max: z.number().nullish(),
    out_of_network_out_of_pocket_remaining: z.number().nullish()
});

export const zMedicalGroupModel = z.object({
    name: z.string().nullish(),
    type: z.string().nullish(),
    address: z.unknown().optional(),
    telephone_numbers: z.string().nullish(),
    website: z.string().nullish()
});

export const zAddress1 = z.object({
    address_line1: z.string().nullish(),
    address_line2: z.string().nullish(),
    city: z.string().nullish(),
    state: z.string().nullish(),
    zip: z.string().nullish(),
    phone_number: z.string().nullish()
});

export const zPatient1 = z.object({
    first_name: z.string().nullish(),
    middle_name: z.string().nullish(),
    last_name: z.string().nullish(),
    date_of_birth: z.string().nullish(),
    alt_first_name: z.string().nullish(),
    alt_last_name: z.string().nullish(),
    alt_date_of_birth: z.string().nullish(),
    gender: z.string().nullish(),
    ssn: z.string().nullish(),
    mrn: z.string().nullish(),
    race_string: z.string().nullish(),
    date_of_death: z.string().nullish(),
    account_external_id: z.string().nullish(),
    address: zAddress1.nullish()
});

export const zRequestEligibility = z.object({
    status: z.string().nullish(),
    reason: z.string().nullish(),
    checked_on: z.iso.datetime().nullish()
});

export const zEligibility = z.object({
    additional_coverage: z.array(zAdditionalCoverage).nullish(),
    certificate_number: z.string().nullish(),
    client_insurance_id: z.string().nullish(),
    cob_order: z.int().nullish(),
    coinsurance: z.number().nullish(),
    deductible: z.number().nullish(),
    deductible_remaining: z.number().nullish(),
    effective_date: z.string().nullish(),
    eligibility271: z.string().nullish(),
    eligibility_status_code: z.string().nullish(),
    eligibility_status_description: z.string().nullish(),
    family_eligibility_cost: zEligibilityCost.nullish(),
    frhc_eligibility_status_code: z.string().nullish(),
    frhc_eligibility_status_description: z.string().nullish(),
    frhc_trace_number: z.unknown().optional(),
    group_name: z.string().nullish(),
    group_number: z.string().nullish(),
    hospital_copay: z.number().nullish(),
    individual_eligibility_cost: zEligibilityCost.nullish(),
    insurance_trace_number: z.string().nullish(),
    is_hospice_care: z.boolean().nullish(),
    matching_business_rules: z.string().nullish(),
    medical_group_model: zMedicalGroupModel.nullish(),
    medicare_part_a: z.boolean().nullish(),
    medicare_part_a_effective_date: z.string().nullish(),
    medicare_part_a_termination_date: z.string().nullish(),
    medicare_part_b: z.boolean().nullish(),
    medicare_part_b_effective_date: z.string().nullish(),
    medicare_part_b_termination_date: z.string().nullish(),
    office_copay: z.number().nullish(),
    other_copay: z.number().nullish(),
    out_of_network_co_insurance: z.number().nullish(),
    out_of_network_deductible: z.number().nullish(),
    out_of_network_deductible_remaining: z.number().nullish(),
    out_of_network_out_of_pocket_max: z.number().nullish(),
    out_of_network_out_of_pocket_remaining: z.number().nullish(),
    out_of_pocket_max: z.number().nullish(),
    out_of_pocket_remaining: z.number().nullish(),
    patient: zPatient1.nullish(),
    payor_name: z.string().nullish(),
    pcp_first_name: z.string().nullish(),
    pcp_last_name: z.string().nullish(),
    plan_type_description: z.string().nullish(),
    plan_type_id: z.int().nullish(),
    rejected: z.boolean().nullish(),
    rejected_reason: z.string().nullish(),
    relation_to_subscriber: z.string().nullish(),
    specialist_copay: z.number().nullish(),
    subscriber: zPatient1.nullish(),
    termination_date: z.string().nullish(),
    trading_partner_id: z.int().nullish(),
    trading_partner_name: z.string().nullish(),
    vendor: z.string().nullish(),
    visit270271_id: z.unknown().optional(),
    carrier_type: z.string().nullish(),
    eligibility: zRequestEligibility.nullish(),
    message: z.string().nullish(),
    carrier_priority: z.int().nullish(),
    created_at: z.string().nullish(),
    fr_trace_id: z.string().nullish(),
    frhc_id: z.int().nullish(),
    manually_entered: z.boolean().nullish(),
    member_id: z.string().nullish(),
    modified_at: z.string().nullish(),
    name: z.string().nullish(),
    plan_code: z.string().nullish(),
    state: z.string().nullish(),
    trace_id: z.int().nullish(),
    updated_at: z.string().nullish()
});

export const zMatchingBusinessRule = z.object({
    business_rule_name: z.string(),
    post: z.boolean(),
    business_rule_number: z.int()
});

export const zEligibilityResponse = z.object({
    pcp_identification_code: z.string().nullish(),
    customer_trace_number: z.string(),
    rejected: z.boolean().nullish(),
    rejected_reason: z.string().nullish(),
    visit_master_id: z.string().nullish(),
    demographic_information: zDemographicInformation.nullish(),
    verified_eligibility: z.array(zEligibility).nullish(),
    discovered_eligibility: z.array(zEligibility).nullish(),
    matching_business_rules: z.array(zMatchingBusinessRule).nullish()
});

export const zFrontRunnerResult = z.object({
    metadata: zFrontRunnerMetaData.optional(),
    payload: z.array(zEligibilityResponse).optional()
});

export const zMockInsuranceDiscoveryPerson = z.object({
    FirstName: z.string(),
    LastName: z.string(),
    DateOfBirth: z.string(),
    Gender: z.string(),
    MRN: z.string().nullish().default(null),
    SSN: z.string().nullish().default(null),
    AddressLine1: z.string().nullish().default(null),
    AddressLine2: z.string().nullish().default(null),
    City: z.string().nullish().default(null),
    State: z.string().nullish().default(null),
    Zip: z.string().nullish().default(null)
});

export const zMockInsuranceInformation = z.object({
    MemberId: z.string().nullish().default(null),
    PayorId: z.string().nullish().default(null),
    GroupNumber: z.string().nullish().default(null)
});

export const zMockInsuranceDiscoveryRequest = z.object({
    UserName: z.string(),
    Password: z.string(),
    CustomerTraceNumber: z.string(),
    Person: zMockInsuranceDiscoveryPerson,
    InsuranceInformation: z.array(zMockInsuranceInformation).optional().default([]),
    DateOfService: z.string(),
    AccountNumber: z.string().nullish().default(null),
    CheckDemographics: z.boolean().optional().default(false),
    CheckCredit: z.boolean().optional().default(false),
    RunDiscovery: z.boolean().optional().default(true),
    RunBusinessRules: z.boolean().optional().default(false),
    ServiceCode: z.int().optional().default(1),
    IsCovid19: z.boolean().optional().default(false)
});

export const zMockAddressResponse = z.object({
    AddressLine1: z.string().nullish(),
    AddressLine2: z.string().nullish(),
    City: z.string().nullish(),
    State: z.string().nullish(),
    Zip: z.string().nullish(),
    PhoneNumber: z.string().nullish()
});

export const zMockPatientResponse = z.object({
    FirstName: z.string().nullish(),
    LastName: z.string().nullish(),
    MiddleName: z.string().nullish(),
    DateOfBirth: z.string().nullish(),
    Gender: z.string().nullish(),
    SSN: z.string().nullish(),
    MRN: z.string().nullish(),
    Address: zMockAddressResponse.nullish()
});

export const zMockSubscriberResponse = z.object({
    FirstName: z.string().nullish(),
    LastName: z.string().nullish(),
    DateOfBirth: z.string().nullish(),
    Gender: z.string().nullish()
});

export const zMockEligibilityRecordResponse = z.object({
    CertificateNumber: z.string().nullish(),
    MemberID: z.string().nullish(),
    GroupNumber: z.string().nullish(),
    GroupName: z.string().nullish(),
    PayorName: z.string().nullish(),
    PayorID: z.string().nullish(),
    TradingPartnerName: z.string().nullish(),
    TradingPartnerID: z.int().nullish(),
    PlanTypeDescription: z.string().nullish(),
    CarrierType: z.string().nullish(),
    EffectiveDate: z.string().nullish(),
    TerminationDate: z.string().nullish(),
    EligibilityStatusCode: z.string().nullish(),
    EligibilityStatusDescription: z.string().nullish(),
    FRHCEligibilityStatusCode: z.string().nullish(),
    FRHCEligibilityStatusDescription: z.string().nullish(),
    COBOrder: z.int().nullish(),
    Coinsurance: z.number().nullish(),
    Deductible: z.number().nullish(),
    DeductibleRemaining: z.number().nullish(),
    OutOfPocketMax: z.number().nullish(),
    OutOfPocketRemaining: z.number().nullish(),
    OutOfNetworkDeductible: z.number().nullish(),
    OutOfNetworkDeductibleRemaining: z.number().nullish(),
    OutOfNetworkOutOfPocketMax: z.number().nullish(),
    OutOfNetworkOutOfPocketRemaining: z.number().nullish(),
    OfficeCopay: z.number().nullish(),
    SpecialistCopay: z.number().nullish(),
    HospitalCopay: z.number().nullish(),
    Rejected: z.boolean().nullish(),
    RejectedReason: z.string().nullish(),
    Patient: zMockPatientResponse.nullish(),
    Subscriber: zMockSubscriberResponse.nullish(),
    RelationToSubscriber: z.string().nullish()
});

export const zMockDemographicInformationResponse = z.object({
    ActiveMilitaryDutyFraudAlert: z.string().nullish(),
    Address: z.string().nullish(),
    AddressActionCode: z.string().nullish(),
    CharityStatus: z.string().nullish(),
    City: z.string().nullish(),
    DeceasedDate: z.string().nullish(),
    DOB: z.string().nullish(),
    DobActionCode: z.string().nullish(),
    EstimatedHouseholdIncome: z.int().nullish(),
    EstimatedHouseholdSize: z.int().nullish(),
    FederalPovertyLevelPercent: z.int().nullish(),
    FirstName: z.string().nullish(),
    Gender: z.string().nullish(),
    LastName: z.string().nullish(),
    MedicaidStatus: z.string().nullish(),
    MiddleName: z.string().nullish(),
    NameActionCode: z.string().nullish(),
    PaymentAdvisorCategory: z.string().nullish(),
    PaymentAdvisorCategoryName: z.string().nullish(),
    PaymentAdvisorScore: z.int().nullish(),
    PaymentAdvisorSuggestion: z.string().nullish(),
    Phone: z.string().nullish(),
    RedFlagActionCode: z.string().nullish(),
    SSN: z.string().nullish(),
    SsnActionCode: z.string().nullish(),
    State: z.string().nullish(),
    TotalAvailCredit: z.number().nullish(),
    TreatmentAssignment: z.string().nullish(),
    Zip: z.string().nullish(),
    AccuracyColor: z.string().nullish(),
    Accuracy: z.string().nullish(),
    RiskIndicator: z.string().nullish(),
    RedFlag: z.string().nullish(),
    CreditScore: z.int().nullish(),
    FRHCRiskIndicator: z.string().nullish(),
    PossiblePhoneNumbers: z.array(z.string()).nullish()
});

export const zMockBusinessRuleResponse = z.object({
    BusinessRuleName: z.string().nullish(),
    Post: z.boolean().nullish(),
    BusinessRuleNumber: z.int().nullish()
});

export const zMockInsuranceDiscoveryResponse = z.object({
    VerifiedEligibility: z.array(zMockEligibilityRecordResponse).nullish(),
    DiscoveredEligibility: z.array(zMockEligibilityRecordResponse).nullish(),
    CustomerTraceNumber: z.string().nullish(),
    Rejected: z.boolean().nullish(),
    RejectedReason: z.string().nullish(),
    VisitMasterID: z.string().nullish(),
    DemographicInformation: zMockDemographicInformationResponse.nullish(),
    MatchingBusinessRules: z.array(zMockBusinessRuleResponse).nullish()
});

export const zTelehealthUpcomingInput = z.object({
    when: z.iso.datetime()
});

export const zInsuranceCardsPut = z.object({
    card_front: z.string().register(z.globalRegistry, {
        description: 'S3 path of the front-of-card image'
    }),
    card_back: z.string().register(z.globalRegistry, {
        description: 'S3 path of the back-of-card image'
    })
});

export const zInsuranceCardsResponse = z.object({
    verification_key: z.string(),
    card_front: z.string().nullish().default(null),
    card_back: z.string().nullish().default(null)
});

export const zUpdateClinicalDocsPhysician = z.object({
    first_name: z.string(),
    last_name: z.string(),
    npi: z.string(),
    phone: z.string().nullish(),
    email: z.email().nullish(),
    address: zAddressInput.nullish(),
    patient_last_visit: z.iso.date()
});

export const zOrderItemIcdInput = z.object({
    code: z.string().optional(),
    description: z.string().optional()
});

export const zUpdateClinicalDocsItemInput = z.object({
    product_id: z.string(),
    variant_key: z.string(),
    quantity: z.int(),
    refill_amount: z.int(),
    additional_information: z.string().optional(),
    icds: z.array(zOrderItemIcdInput)
});

export const zUpdateClinicalDocsInput = z.object({
    physician: zUpdateClinicalDocsPhysician,
    items: z.array(zUpdateClinicalDocsItemInput)
});

export const zUpdateClinicalDocsResponse = z.object({
    physician: z.record(z.string(), z.unknown()).optional(),
    items: z.array(z.record(z.string(), z.unknown())).optional()
});

export const zRequirement = z.object({
    key: z.string(),
    description: z.string(),
    hcpcs: z.array(z.string()),
    question: z.string(),
    answers: z.array(zAnswer)
});

export const zLomnRequirementsResponse = z.object({
    requirements: z.array(zRequirement)
});

export const zTelehealthCompletedInput = z.object({
    when: z.iso.datetime().nullish().default(null)
});

export const zFunctionalInsurance = z.object({
    state: z.string().register(z.globalRegistry, {
        description: 'State code'
    }),
    frhc_id: z.int().register(z.globalRegistry, {
        description: 'Frontrunner Carrier ID'
    }),
    member_id: z.string().register(z.globalRegistry, {
        description: 'Member ID'
    }),
    carrier_type: z.string().nullish().default(null)
});

export const zNonFunctionalInsurance = z.object({
    state: z.string().register(z.globalRegistry, {
        description: 'State code'
    }),
    frhc_id: z.int().register(z.globalRegistry, {
        description: 'Frontrunner Carrier ID'
    }),
    member_id: z.string().nullish().default(null),
    carrier_type: z.string().nullish().default(null)
});

export const zAssignInsurancesRequest = z.object({
    primary: zFunctionalInsurance,
    secondary: zFunctionalInsurance.nullish(),
    others: z.array(zNonFunctionalInsurance).nullish().default(null)
});

export const zAssignInsurancesResponse = z.object({
    message: z.string().register(z.globalRegistry, {
        description: 'Response message'
    }),
    order_id: z.string().register(z.globalRegistry, {
        description: 'The order ID that was assigned insurances'
    })
});

export const zInsuranceInformation = z.object({
    trading_partner_id: z.int().optional(),
    insurance_trace_number: z.string().nullish(),
    certificate_number: z.string().nullish()
});

export const zFrontRunnerEligibilityInput = z.object({
    patient: zPerson.optional(),
    insurance: z.array(zInsuranceInformation).optional()
});

export const zOnHoldWithSupplierInput = z.object({
    reason: z.string()
});

export const zOrderFileUrlResponse = z.object({
    key: z.string().register(z.globalRegistry, {
        description: 'AWS file key'
    }),
    url: z.string().register(z.globalRegistry, {
        description: 'AWS presigned url'
    })
});

export const zOrderFilesUrlResponse = z.object({
    metadata: zBaseMetadata,
    payload: zOrderFileUrlResponse
});

export const zUpdatePlanCode = z.object({
    plan_uuid: z.uuid().nullish().default(null),
    code: z.string().max(100).nullish().default(null),
    is_active: z.boolean().nullish().default(null),
    is_visible: z.boolean().nullish().default(null)
});

export const zUpdateOrderAddressResponse = z.object({
    metadata: z.record(z.string(), z.unknown()).optional(),
    payload: z.unknown().optional()
});

export const zFulfillmentEditInput = z.object({
    authorization_status: z.enum([
        'NOT_STARTED',
        'SUCCESS',
        'FAILURE',
        'IN_PROGRESS',
        'NOT_REQUIRED'
    ]).register(z.globalRegistry, {
        description: 'The authorization status to set'
    }),
    submitted_by: z.string().nullish().default(null),
    submitted_via: z.string().nullish().default(null),
    authorization_fingerprint: z.string().nullish().default(null),
    authorization_date_complete: z.iso.datetime().nullish().default(null),
    authorization_date_start: z.iso.datetime().nullish().default(null)
});

export const zFulfillmentUpdatedResponse = z.object({
    message: z.string().register(z.globalRegistry, {
        description: 'A message indicating the result of the fulfillment update'
    }),
    fulfillment_uuid: z.string().register(z.globalRegistry, {
        description: 'The UUID of the updated fulfillment'
    }),
    authorization_status: z.string().register(z.globalRegistry, {
        description: 'The updated authorization status of the fulfillment'
    })
});

export const zLuminaMetaData = z.object({
    timestamp: z.string().optional(),
    duration: z.string(),
    function_profile: z.unknown().optional(),
    input_parameters: z.unknown().optional()
});

export const zLuminaPatient = z.object({
    id: z.string(),
    first_name: z.string(),
    last_name: z.string(),
    dob: z.string(),
    gender: z.string()
});

export const zLuminaContact = z.object({
    first_name: z.string(),
    last_name: z.string(),
    phone_number: z.string(),
    preferred_language: z.string(),
    relationship: z.string()
});

export const zLuminaInsurance = z.object({
    member_id: z.string(),
    group_number: z.string(),
    plan_code: z.string(),
    plan_name: z.string(),
    state: z.string()
});

export const zLuminaShippingAddress = z.object({
    street: z.string().register(z.globalRegistry, {
        description: 'Street address'
    }),
    complement: z.string().register(z.globalRegistry, {
        description: 'Apartment or unit info'
    }),
    city: z.string().register(z.globalRegistry, {
        description: 'City name'
    }),
    state: z.string().register(z.globalRegistry, {
        description: 'Two-letter US state abbreviation'
    }),
    zip_code: z.string().register(z.globalRegistry, {
        description: 'ZIP code'
    })
});

export const zLuminaProductProperties = z.object({
    name: z.string().optional(),
    value: z.string().optional()
});

export const zLuminaOrderProduct = z.object({
    title: z.string().optional(),
    description: z.string().optional(),
    quantity: z.int().register(z.globalRegistry, {
        description: 'Quantity of the product in the order'
    }),
    refill_amount: z.int().register(z.globalRegistry, {
        description: 'Refill Quantity'
    }),
    properties: z.array(zLuminaProductProperties).optional(),
    hcpc_codes: z.array(z.string()).optional()
});

export const zLuminaOrderResult = z.object({
    order_id: z.string(),
    patient: zLuminaPatient,
    primary_contact: zLuminaContact,
    primary_insurance: zLuminaInsurance,
    secondary_insurance: zLuminaInsurance,
    shipping_address: zLuminaShippingAddress.optional(),
    order_items: z.array(zLuminaOrderProduct).register(z.globalRegistry, {
        description: 'List of items included in the order'
    })
});

export const zLuminaResult = z.object({
    response: z.unknown().optional(),
    order: zLuminaOrderResult.optional()
});

export const zLuminaResponse = z.object({
    metadata: zLuminaMetaData.optional(),
    payload: zLuminaResult.optional()
});

export const zCczpCreate = z.object({
    product_uuid: z.string(),
    carrier_uuid: z.string(),
    coverage_zone_uuid: z.string(),
    supplier_uuids: z.array(z.uuid()),
    properties: z.array(zProperty1),
    variants: z.array(zVariant1),
    is_active: z.boolean(),
    is_visible: z.boolean()
});

export const zCczpCreateResponse = z.object({
    uuid: z.uuid(),
    carrier_coverage_zone_uuid: z.uuid()
});

export const zEditFeeScheduleInput = z.object({
    fee: z.number(),
    rental_fee: z.number(),
    max_refills: z.int(),
    max_units: z.int(),
    pa: z.int()
});

/**
 * Fee Schedule Details
 */
export const zFeeScheduleResponse = z.object({
    fee: z.number().nullish(),
    rental_fee: z.number().nullish(),
    max_units: z.int().nullish(),
    pa: z.int().nullish(),
    json_data: z.unknown().optional(),
    uuid: z.uuid().optional(),
    created_at: z.iso.datetime().nullish(),
    modified_at: z.iso.datetime().nullish(),
    is_visible: z.boolean().optional(),
    is_active: z.boolean().optional()
}).register(z.globalRegistry, {
    description: 'Fee Schedule Details'
});

export const zSearchProductMetaData = z.object({
    timestamp: z.string().optional(),
    duration: z.string(),
    total: z.int(),
    count: z.int(),
    q: z.string().optional(),
    pagination: zPagination.optional(),
    sorting: zSort.optional(),
    queries: z.unknown().optional(),
    function_profile: z.unknown().optional(),
    input_parameters: z.unknown().optional()
});

/**
 * Product Category
 */
export const zProductCategorySchemaV2 = z.object({
    parent: z.lazy((): any => zProductCategorySchemaV2).optional(),
    uuid: z.uuid().optional(),
    label: z.string().max(255),
    description: z.string().nullish(),
    image_url: z.string().max(1024).nullish(),
    json_data: z.unknown().optional(),
    created_at: z.iso.datetime().nullish(),
    modified_at: z.iso.datetime().nullish(),
    is_visible: z.boolean().optional(),
    is_active: z.boolean().optional()
}).register(z.globalRegistry, {
    description: 'Product Category'
});

/**
 * Product Details
 */
export const zProductSchemaV2 = z.object({
    status: z.string().optional(),
    categories: z.array(zProductCategorySchemaV2).optional(),
    name: z.string().max(255),
    description: z.string().nullish(),
    properties: z.unknown().optional(),
    media: z.unknown().optional(),
    integrations: z.unknown().optional(),
    json_data: z.unknown().optional(),
    uuid: z.uuid().optional(),
    created_at: z.iso.datetime().nullish(),
    modified_at: z.iso.datetime().nullish(),
    is_visible: z.boolean().optional(),
    is_active: z.boolean().optional()
}).register(z.globalRegistry, {
    description: 'Product Details'
});

export const zCarrierProductSchemaV2 = z.object({
    uuid: z.string().optional(),
    product_mongo_key: z.string().optional(),
    json_data: z.record(z.string(), z.unknown()).optional(),
    product: zProductSchemaV2.optional()
});

export const zSearchCarrierProductsResults = z.object({
    metadata: zSearchProductMetaData.optional(),
    payload: z.array(zCarrierProductSchemaV2).optional()
});

export const zUpdateCodeEligibilityOverrideInput = z.object({
    override: z.string().nullish().default(null),
    notes: z.string().nullish().default(null),
    code_uuid: z.string().nullish().default(null),
    plan_type: z.string().nullish().default(null),
    plan_uuid: z.string().nullish().default(null),
    plan_code_uuid: z.string().nullish().default(null)
});

export const zTelehealthNeedsReschedulingInput = z.object({
    reason: z.string().nullish().default(null)
});

export const zUpdateNetworkStatusDesignationInput = z.object({
    service_line: z.string().nullish().default(null),
    status: z.string().nullish().default(null),
    plan_type: z.string().nullish().default(null),
    plan_uuid: z.string().nullish().default(null),
    plan_code_uuid: z.string().nullish().default(null)
});

export const zProduct2 = z.object({
    uuid: z.uuid(),
    product_id: z.string().optional(),
    name: z.string(),
    description: z.string().optional()
});

export const zCarrier = z.object({
    uuid: z.uuid(),
    name: z.string()
});

export const zCoverageZone2 = z.object({
    uuid: z.uuid(),
    label: z.string(),
    abbreviation: z.string()
});

export const zCarrierCoverageZone = z.object({
    uuid: z.uuid(),
    payer_id: z.string().optional()
});

export const zCczpDetails = z.object({
    uuid: z.uuid(),
    product: zProduct2,
    carrier: zCarrier,
    coverage_zone: zCoverageZone2,
    carrier_coverage_zone: zCarrierCoverageZone,
    supplier_ids: z.array(z.int()).optional(),
    properties: z.array(zProperty1).optional(),
    variants: z.array(zVariant1).optional(),
    version: z.int().optional(),
    is_active: z.boolean().optional(),
    is_visible: z.boolean().optional()
});

export const zFrontRunnerCarriers = z.object({
    default_primary_medicaid: zEligibility.optional(),
    default_primary_medicare: zEligibility.optional(),
    default_secondary_medicaid: zEligibility.optional(),
    default_secondary_medicare: zEligibility.optional(),
    primary_medicaid: zEligibility.optional(),
    primary_medicare: zEligibility.optional(),
    primary_private: zEligibility.optional(),
    secondary_medicaid: zEligibility.optional(),
    secondary_medicare: zEligibility.optional(),
    secondary_primary_medicaid: zEligibility.optional(),
    secondary_primary_medicare: zEligibility.optional(),
    secondary_private: zEligibility.optional()
});

export const zFrontRunnerPrioritizedEntry = z.object({
    insurance: zEligibility.optional(),
    secondary_insurance: zEligibility.optional(),
    all: z.array(zEligibility).nullish(),
    carriers: zFrontRunnerCarriers.nullish()
});

export const zFrontRunnerPrioritizedResult = z.object({
    metadata: zFrontRunnerMetaData.optional(),
    payload: z.array(zFrontRunnerPrioritizedEntry).optional()
});

export const zToggleNpiAddressInput = z.object({
    is_active: z.boolean().register(z.globalRegistry, {
        description: 'Provider email address'
    })
});

export const zUpdateItemInput = z.object({
    variant_key: z.string().nullish().default(null),
    quantity: z.int(),
    refill_amount: z.int(),
    length_of_need: z.int().optional(),
    additional_information: z.string().optional(),
    icds: z.array(zOrderItemIcdInput)
});

export const zUpdateOrderItemResponse = z.object({
    metadata: z.record(z.string(), z.unknown()).optional(),
    payload: z.unknown().optional()
});

export const zFrontRunnerInsuranceHistory = z.object({
    updated_at: z.iso.datetime().nullish(),
    discovered: z.array(zEligibility).nullish(),
    prioritized: zFrontRunnerCarriers.nullish()
});

export const zFrontRunnerMongoEntry = z.object({
    insurance: zEligibility.nullish(),
    secondary_insurance: zEligibility.nullish(),
    insurance_history: zFrontRunnerInsuranceHistory.nullish()
});

export const zFrontRunnerMongoUpdate = z.object({
    metadata: zFrontRunnerMetaData.optional(),
    payload: zFrontRunnerMongoEntry.optional()
});

export const zCczpEditInput = z.object({
    supplier_uuids: z.array(z.uuid()).optional(),
    is_visible: z.boolean().optional(),
    properties: z.array(zProperty1).optional(),
    variants: z.array(zVariant1).optional()
});

export const zCczpEditResponse = z.object({
    uuid: z.uuid()
});

export const zManualVerificationRequest = z.object({
    verified: z.boolean().register(z.globalRegistry, {
        description: 'True to mark the insurance manually verified; false to clear verification.'
    }),
    insurance_member_id: z.string().register(z.globalRegistry, {
        description: 'Member ID currently on the targeted insurance slot. Server 409s if the slot has shifted (e.g., other_insurances re-ordered) and no longer matches.'
    }),
    insurance_name: z.string().register(z.globalRegistry, {
        description: 'Insurance name currently on the targeted slot. Compared case-insensitive, trimmed.'
    }),
    source: z.enum(['INSURANCE_CARD', 'OTHER']).register(z.globalRegistry, {
        description: 'Required when verified=true; ignored when verified=false.'
    }).optional()
});

export const zManualVerificationResponse = z.object({
    manually_verified_at: z.iso.datetime().nullish().default(null),
    manually_verified_by: z.string().nullish().default(null),
    manually_verified_source: z.enum(['INSURANCE_CARD', 'OTHER']).optional()
});

export const zGetCarrierProductResults = z.object({
    metadata: zSearchProductMetaData.optional(),
    payload: zCarrierProductSchemaV2.optional()
});

export const zDbAdminLegacyDbDiagramResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'image/png'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

export const zDbAdminLegacyDbDiagramPostResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'image/png'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

export const zDbAdminLegacyDbDiagram2Response = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'image/png'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

export const zDbAdminLegacyDbDiagramPost2Response = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'image/png'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

export const zDbAdminLegacyFulfillmentsResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

export const zDbAdminLegacyFulfillments2Response = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

export const zDbAdminLegacyFulfillments3Response = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

/**
 * OK
 */
export const zDbAdminLegacyTokenValidationResponse = zV1DbAdminTokenResponse;

export const zAuthorizationV1AuthorizeApiTokenResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

export const zAuthorizationV1AuthorizeApiToken2Response = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

/**
 * OK
 */
export const zAuthorizationV1HeartbeatResponse = zHeartbeat;

/**
 * No Content
 */
export const zAuthorizationV1TestStateMismatchResponse = z.void().register(z.globalRegistry, {
    description: 'No Content'
});

export const zDbAdminV1DbDiagramResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'image/png'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

export const zDbAdminV1DbDiagramPostResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'image/png'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

export const zDbAdminV1DbDiagram2Response = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'image/png'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

export const zDbAdminV1DbDiagramPost2Response = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'image/png'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

export const zDbAdminV1FulfillmentsResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

export const zDbAdminV1Fulfillments2Response = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

export const zDbAdminV1Fulfillments3Response = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

/**
 * OK
 */
export const zDbAdminV1TokenValidationResponse = zV1DbAdminTokenResponse;

/**
 * No Content
 */
export const zEsignatureV1EventCallbackResponse = z.void().register(z.globalRegistry, {
    description: 'No Content'
});

/**
 * OK
 */
export const zEsignatureV1OnScreenSignResponse = zEsignatureResponse;

/**
 * OK
 */
export const zEsignatureV1RequestOrderEsignatureResponse = zEsignatureResponse;

export const zEsignatureV1RefreshOrderEsignatureResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

/**
 * OK
 */
export const zInsuranceV1CategoriesV1DetailsResponse = zCodeCategory;

/**
 * OK
 */
export const zInsuranceV1CategoriesV1HeartbeatResponse = zHeartbeat;

/**
 * OK
 */
export const zInsuranceV1CategoriesV1SearchResponse = z.array(zCodeCategory).register(z.globalRegistry, {
    description: 'OK'
});

/**
 * OK
 */
export const zInsuranceV1CategoriesV1Search2Response = z.array(zCodeCategory).register(z.globalRegistry, {
    description: 'OK'
});

/**
 * OK
 */
export const zInsuranceV1DetailsResponse = zInsurance1;

/**
 * OK
 */
export const zInsuranceV1HeartbeatResponse = zHeartbeat;

/**
 * OK
 */
export const zInsuranceV1SearchResponse = z.array(zInsurance1).register(z.globalRegistry, {
    description: 'OK'
});

/**
 * OK
 */
export const zInsuranceV1Search2Response = z.array(zInsurance1).register(z.globalRegistry, {
    description: 'OK'
});

/**
 * OK
 */
export const zManagementV1FeeScheduleV1UpdateFeeScheduleResponse = zFeeScheduleResponse;

/**
 * OK
 */
export const zNpiV1SearchProvidersResponse = z.array(zProviderResponse).register(z.globalRegistry, {
    description: 'OK'
});

/**
 * OK
 */
export const zNpiV1GetProviderResponse = zProviderResponse;

/**
 * Multi Status
 */
export const zOrdersV1AuthorizeResponse = zAuthorizationResponse;

/**
 * application/json
 */
export const zOrdersV1BillingResponse = z.void().register(z.globalRegistry, {
    description: 'application/json'
});

/**
 * OK
 */
export const zOrdersV1GetChangeReasonsResponse = zOrderReasonsResponse;

/**
 * Created
 */
export const zOrdersV1CreateOrderEndpointResponse = zOrderDetailResponse;

export const zOrdersV1MoveTempFilesToOrderResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

/**
 * OK
 */
export const zOrdersV1UploadOrderTmpFileResponse = zUploadOrderTempDocumentsResponse;

/**
 * OK
 */
export const zOrdersV1UpdateFulfillmentResponse = zFulfillmentUpdatedResponse;

/**
 * OK
 */
export const zOrdersV1GetFulfillmentsResponse = zGetFulfillmentsResponse;

/**
 * OK
 */
export const zOrdersV1GetIneligibilityReasonsResponse = zOrderReasonsResponse;

/**
 * OK
 */
export const zOrdersV1GetOnHoldReasonsResponse = zOrderReasonsResponse;

/**
 * OK
 */
export const zOrdersV1GetRejectionReasonsResponse = zOrderReasonsResponse;

/**
 * No Content
 */
export const zOrdersV1BackfillRxDateResponse = z.void().register(z.globalRegistry, {
    description: 'No Content'
});

/**
 * OK
 */
export const zOrdersV1OrderListResponse = zOrderListResponse;

/**
 * OK
 */
export const zOrdersV1SearchPatientsWithOrdersResponse = zPatientSearchResponse;

/**
 * OK
 */
export const zOrdersV1GetTelehealthErrorReasonsResponse = zOrderReasonsResponse;

/**
 * OK
 */
export const zOrdersV1OrderDetailsResponse = zOrderDetailResponse;

/**
 * OK
 */
export const zOrdersV1AcceptOrderResponse = zOrderTransitionResponse1;

/**
 * OK
 */
export const zOrdersV1UpdateOrderAssigneeResponse = zUpdateAssigneeResponse;

/**
 * application/json
 */
export const zOrdersV1AuthRecoveryResponse = z.void().register(z.globalRegistry, {
    description: 'application/json'
});

/**
 * application/json
 */
export const zOrdersV1ReviewAuthSubmissionResponse = z.void().register(z.globalRegistry, {
    description: 'application/json'
});

/**
 * OK
 */
export const zOrdersV1GetCarrierCoverageZoneProductsResponse = z.array(zCczpDetails).register(z.globalRegistry, {
    description: 'OK'
});

/**
 * OK
 */
export const zOrdersV1UpdateOrderClinicalDocsResponse = zUpdateClinicalDocsResponse;

/**
 * OK
 */
export const zOrdersV1UpdateOrderContactResponse = zUpdateOrderContactResponse;

/**
 * OK
 */
export const zOrdersV1GetOrderFilesResponse = zOrderFilesResponse;

/**
 * OK
 */
export const zOrdersV1UploadOrderFileResponse = zUploadOrderDocumentsResponse;

export const zOrdersV1DeleteOrderFileResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

/**
 * OK
 */
export const zOrdersV1GetOrderFileResponse = zOrderFilesUrlResponse;

/**
 * Created
 */
export const zOrdersV1DuplicateOrderEndpointResponse = zCreateOrderResponse1;

/**
 * application/json
 */
export const zOrdersV1ToggleFulfillmentActiveResponse = z.void().register(z.globalRegistry, {
    description: 'application/json'
});

/**
 * application/json
 */
export const zOrdersV1ToggleFulfillmentInactiveResponse = z.void().register(z.globalRegistry, {
    description: 'application/json'
});

/**
 * OK
 */
export const zOrdersV1GetInsuranceCardDownloadUrlResponse = zInsuranceCardDownloadResponse;

/**
 * OK
 */
export const zOrdersV1UpdateOrderInsuranceResponse = zUpdateOrderInsuranceResponse;

/**
 * OK
 */
export const zOrdersV1AssignOrderInsurancesResponse = zAssignInsurancesResponse;

/**
 * OK
 */
export const zOrdersV1DeleteOrderProductsResponse = zUpdateOrderItemResponse;

/**
 * OK
 */
export const zOrdersV1UpdateOrderProductsResponse = zUpdateOrderItemResponse;

/**
 * OK
 */
export const zOrdersV1UpdateOrderPatientResponse = zUpdateOrderPatientResponse;

/**
 * OK
 */
export const zOrdersV1UpdateOrderPhysicianResponse = zUpdateOrderPhysicianResponse;

/**
 * OK
 */
export const zOrdersV1UpdateOrderReferralResponse = zUpdateOrderReferralResponse;

/**
 * OK
 */
export const zOrdersV1RejectOrderResponse = zOrderTransitionResponse1;

/**
 * OK
 */
export const zOrdersV1RequestOrderChangesResponse = zOrderTransitionResponse1;

/**
 * OK
 */
export const zOrdersV1UpdateRxDateResponse = zRxDateUpdateResponse;

/**
 * Created
 */
export const zOrdersV1OrderScheduleResupplyResponse = zCreateOrderResponse1;

/**
 * OK
 */
export const zOrdersV1UpdateOrderShippingAddressResponse = zUpdateOrderAddressResponse;

/**
 * application/json
 */
export const zOrdersV1SkipOrderResponse = z.void().register(z.globalRegistry, {
    description: 'application/json'
});

/**
 * application/json
 */
export const zOrdersV1SkipOrder2Response = z.void().register(z.globalRegistry, {
    description: 'application/json'
});

/**
 * OK
 */
export const zOrdersV1UpdateOrderSupplierResponse = zUpdateOrderSupplierResponse;

/**
 * Created
 */
export const zOrganizationsV1CreateOrganizationResponse = zOrganizationDetailsResponse;

/**
 * OK
 */
export const zOrganizationsV1SearchOrganizationsResponse = zOrganizationsResponse;

/**
 * OK
 */
export const zOrganizationsV1GetOrganizationResponse = zOrganizationDetailsResponse;

/**
 * OK
 */
export const zOrganizationsV1UpdateOrganizationResponse = zOrganizationDetailsResponse;

/**
 * OK
 */
export const zProductsV1CategoriesV1HeartbeatResponse = zHeartbeat;

/**
 * No Content
 */
export const zProductsV1CategoriesV1SearchResponse = z.void().register(z.globalRegistry, {
    description: 'No Content'
});

/**
 * OK
 */
export const zProductsV1ProductDetailsResponse = zProduct1;

/**
 * OK
 */
export const zProductsV1HeartbeatResponse = zHeartbeat;

/**
 * OK
 */
export const zProductsV1SearchProductsResponse = zSearchProductResult;

/**
 * OK
 */
export const zServicesV1Auth0V1HeartbeatResponse = zHeartbeat;

export const zServicesV1Auth0V1GetAuth0UserResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

export const zServicesV1Auth0V1ListAuth0UsersResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

export const zServicesV1Auth0V1DuplicateAuth0UsersResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

export const zServicesV1Auth0V1ExportAuth0UsersResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

export const zServicesV1Auth0V1ListAuth0Users2Response = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

export const zServicesV1CandidV1GenerateEncounterPayloadResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'Raw JSON response'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

/**
 * OK
 */
export const zServicesV1CandidV1HeartbeatResponse = zHeartbeat;

/**
 * OK
 */
export const zServicesV1EpacesV1GetEligibilityResponsesResponse = zEpacesEligibilityResponse;

/**
 * OK
 */
export const zServicesV1EpacesV1HeartbeatResponse = zHeartbeat;

/**
 * OK
 */
export const zServicesV1EpacesV1GetPriorAuthorizationResponsesResponse = zEpacesPriorAuthorizationResponse;

/**
 * OK
 */
export const zServicesV1EpacesV1GetPriorAuthorizationResponsesForOrderResponse = zEpacesPriorAuthorizationResponse;

/**
 * OK
 */
export const zServicesV1EpacesV1CancelPriorAuthorizationsForOrderResponse = zEpacesPriorAuthorizationResponse;

/**
 * OK
 */
export const zServicesV1EpacesV1CancelPriorAuthorizationsForOrder2Response = zEpacesPriorAuthorizationResponse;

export const zServicesV1EpacesV1SubmitPriorAuthorizationForOrderResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

export const zServicesV1EpacesV1SubmitPriorAuthorizationForOrder2Response = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

/**
 * OK
 */
export const zServicesV1FrontrunnerV1PrioritizedDiscoveryByOrderEndpointResponse = zFrontRunnerPrioritizedResult;

/**
 * OK
 */
export const zServicesV1FrontrunnerV1DiscoveryByOrderEndpointResponse = zFrontRunnerResult;

/**
 * OK
 */
export const zServicesV1FrontrunnerV1DiscoveryByPatientEndpointResponse = zFrontRunnerResult;

/**
 * OK
 */
export const zServicesV1FrontrunnerV1PrioritizedDiscoveryByPatientEndpointResponse = zFrontRunnerPrioritizedResult;

export const zGetServicesV1FrontrunnerV1MongoDiscoveryEventResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

export const zPostServicesV1FrontrunnerV1MongoDiscoveryEventResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

/**
 * OK
 */
export const zServicesV1FrontrunnerV1MongoDiscoverySourceResponse = zFrontRunnerMongoUpdate;

/**
 * OK
 */
export const zServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpointResponse = zFrontRunnerPrioritizedResult;

/**
 * OK
 */
export const zServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpoint2Response = zFrontRunnerPrioritizedResult;

/**
 * OK
 */
export const zServicesV1FrontrunnerV1EligibilityByOrderEndpointResponse = zFrontRunnerResult;

/**
 * OK
 */
export const zServicesV1FrontrunnerV1EligibilityByOrderEndpoint2Response = zFrontRunnerResult;

/**
 * OK
 */
export const zServicesV1FrontrunnerV1EligibilityByPatientEndpointResponse = zFrontRunnerResult;

/**
 * OK
 */
export const zServicesV1FrontrunnerV1PrioritizedEligibilityByPatientEndpointResponse = zFrontRunnerPrioritizedResult;

export const zServicesV1FrontrunnerV1MongoEligibilityEventResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

export const zServicesV1FrontrunnerV1MongoEligibilityEvent2Response = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

/**
 * OK
 */
export const zServicesV1FrontrunnerV1MongoEligibilitySourceResponse = zFrontRunnerMongoUpdate;

/**
 * OK
 */
export const zServicesV1FrontrunnerV1MongoEligibilitySource2Response = zFrontRunnerMongoUpdate;

/**
 * OK
 */
export const zServicesV1FrontrunnerV1HeartbeatResponse = zHeartbeat;

/**
 * OK
 */
export const zServicesV1FrontrunnerV1MockDiscoveryResponse = zMockInsuranceDiscoveryResponse;

/**
 * OK
 */
export const zServicesV1HeartbeatResponse = zHeartbeat;

/**
 * OK
 */
export const zServicesV1HubspotV1ContactsResponse = zHubSpotContactResults;

export const zServicesV1HubspotV1IngestContactsResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

/**
 * OK
 */
export const zServicesV1HubspotV1HeartbeatResponse = zHeartbeat;

/**
 * OK
 */
export const zServicesV1HubspotV1OrdersResponse = zHubSpotOrderResults;

export const zServicesV1HubspotV1IngestOrdersResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

/**
 * OK
 */
export const zServicesV1HubspotV1ProductsResponse = zHubSpotProductResults;

/**
 * No Content
 */
export const zServicesV1IntercomV1IntercomSendReplyResponse = z.void().register(z.globalRegistry, {
    description: 'No Content'
});

/**
 * OK
 */
export const zServicesV1LuminaV1HeartbeatResponse = zHeartbeat;

/**
 * OK
 */
export const zServicesV1LuminaV1SubmitOrderResponse = zLuminaResponse;

/**
 * No Content
 */
export const zServicesV1SlackV1SlackPostResponse = z.void().register(z.globalRegistry, {
    description: 'No Content'
});

/**
 * OK
 */
export const zSuppliersV1GetAllSuppliersResponse = z.array(zSupplier1).register(z.globalRegistry, {
    description: 'OK'
});

/**
 * OK
 */
export const zSuppliersV1DetailsResponse = zSearchSupplierResults;

/**
 * OK
 */
export const zSuppliersV1HeartbeatResponse = zHeartbeat;

/**
 * OK
 */
export const zSuppliersV1SearchResponse = zSearchSupplierResults;

/**
 * OK
 */
export const zSuppliersV1Search2Response = zSearchSupplierResults;

export const zSystemV1AggregateLegacyContactsResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

/**
 * OK
 */
export const zSystemV1AnalyzeProgressNoteRouteResponse = zAnalyzeProgressNoteResponse;

export const zSystemV1AxiomStatusResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

export const zSystemV1ClearAxiomResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

export const zSystemV1MessageConversionEventsResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'Request received'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

export const zSystemV1CurrentAxiomResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

export const zSystemV1DisableCurrentAxiomOrderResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

export const zSystemV1EpacesResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

/**
 * OK
 */
export const zSystemV1GenerateLomnRouteResponse = zLoMnDetails;

/**
 * OK
 */
export const zSystemV1HeartbeatResponse = zHeartbeat;

/**
 * No Content
 */
export const zSystemV1ProduceMessageResponse = z.void().register(z.globalRegistry, {
    description: 'No Content'
});

/**
 * OK
 */
export const zSystemV1LomnHistoryResponse = zLoMnHistoryResponse;

/**
 * No Content
 */
export const zSystemV1LomnPdfResponse = z.void().register(z.globalRegistry, {
    description: 'No Content'
});

/**
 * OK
 */
export const zSystemV1LomnRequirementsResponse = zLomnRequirementsResponse;

export const zSystemV1MigrateLegacyPatientsRouteResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

export const zSystemV1MigrateMongoOrdersRouteResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

export const zSystemV1MongoHealthResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

export const zSystemV1ListOrderedTablesResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

export const zSystemV1ListOrderedTables2Response = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

/**
 * OK
 */
export const zSystemV1PdfReaderResponse = zFileResults;

export const zSystemV1SyncMongoOrdersByIdResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

export const zSystemV1TriggerResupplyReportResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

/**
 * Created
 */
export const zUsersV1CreateUserResponse = zCreateUserResponseEnvelope;

/**
 * OK
 */
export const zUsersV1ActivateUserResponse = zUserResponseEnvelope;

/**
 * OK
 */
export const zUsersV1SearchUsersResponse = zListUserResponse;

/**
 * OK
 */
export const zUsersV1DeleteUserResponse = zUserResponseEnvelope;

/**
 * OK
 */
export const zUsersV1GetUserResponse = zUserDetailsResponse1;

/**
 * OK
 */
export const zUsersV1UpdateUserResponse = zUserResponseEnvelope;

/**
 * OK
 */
export const zInsuranceV2GetCarriersByStateResponse = z.array(zCarrierByState).register(z.globalRegistry, {
    description: 'OK'
});

/**
 * OK
 */
export const zInsuranceV2GetCoverageZonesResponse = z.array(zCoverageZone).register(z.globalRegistry, {
    description: 'OK'
});

/**
 * OK
 */
export const zInsuranceV2RefillsResponse = zFeeScheduleResults;

/**
 * OK
 */
export const zInsuranceV2HeartbeatResponse = zHeartbeat;

/**
 * OK
 */
export const zInsuranceV2SearchIcdsResponse = zIcdSearchResponse;

/**
 * OK
 */
export const zInsuranceV2GetPrimaryIcdsResponse = zIcdResponse;

/**
 * OK
 */
export const zInsuranceV2GetCarrierProductLegacyResponse = zCarrierProductSchemaV2;

/**
 * OK
 */
export const zInsuranceV2GetCarrierProductResponse = zGetCarrierProductResults;

/**
 * OK
 */
export const zInsuranceV2GetCarrierProductsResponse = zSearchCarrierProductsResults;

/**
 * OK
 */
export const zNpiV2SearchProvidersResponse = zSearchNpiResponse;

/**
 * OK
 */
export const zNpiV2GetProviderResponse = zGetNpiResponse;

/**
 * OK
 */
export const zNpiV2UpdateProviderResponse = zGetNpiResponse;

/**
 * OK
 */
export const zNpiV2AddProviderAddressResponse = zNpiAddressResponse;

/**
 * OK
 */
export const zNpiV2UpdateProviderAddressResponse = zNpiAddressResponse;

/**
 * OK
 */
export const zNpiV2ToggleProviderAddressResponse = zNpiAddressResponse;

/**
 * OK
 */
export const zOrdersV2GetOrderStatusesV2Response = zOrderStatusesResponse;

/**
 * OK
 */
export const zOrdersV2MoveOrderToBillingResponse = zOrderTransitionResponse;

/**
 * OK
 */
export const zOrdersV2MoveOrderToCantReachPatientResponse = zOrderTransitionResponse;

/**
 * OK
 */
export const zOrdersV2MoveOrderToDoneResponse = zOrderTransitionResponse;

/**
 * OK
 */
export const zOrdersV2DuplicateOrderV2Response = zOrderTransitionResponse;

/**
 * OK
 */
export const zOrdersV2MoveOrderToInProgressWithSupplierResponse = zOrderTransitionResponse;

/**
 * OK
 */
export const zOrdersV2MoveOrderToOnHoldWithSupplierResponse = zOrderTransitionResponse;

/**
 * OK
 */
export const zOrdersV2MoveOrderToPendingAuthorizationResponse = zOrderTransitionResponse;

/**
 * OK
 */
export const zOrdersV2MoveOrderToPendingRerouteResponse = zOrderTransitionResponse;

/**
 * OK
 */
export const zOrdersV2MoveOrderToPendingSupplierAcceptanceResponse = zOrderTransitionResponse;

/**
 * OK
 */
export const zOrdersV2MoveOrderToPreparingShipmentResponse = zOrderTransitionResponse;

/**
 * OK
 */
export const zOrdersV2RefreshEsignatureResponse = zOrderTransitionResponse;

/**
 * OK
 */
export const zOrdersV2RequestEsignatureResponse = zOrderTransitionResponse;

/**
 * OK
 */
export const zOrdersV2MoveOrderToSupplierCompletedResponse = zOrderTransitionResponse;

/**
 * OK
 */
export const zOrdersV2MoveOrderToSupplierShippedResponse = zOrderTransitionResponse;

/**
 * OK
 */
export const zOrdersV2MoveOrderToTelehealthChasingClinicalsResponse = zOrderTransitionResponse;

/**
 * OK
 */
export const zOrdersV2MoveOrderToTelehealthCompletedResponse = zOrderTransitionResponse;

/**
 * OK
 */
export const zOrdersV2MoveOrderToTelehealthContactingPatientResponse = zOrderTransitionResponse;

/**
 * OK
 */
export const zOrdersV2MoveOrderToTelehealthNeedsReschedulingResponse = zOrderTransitionResponse;

/**
 * OK
 */
export const zOrdersV2MoveOrderToTelehealthOnHoldResponse = zOrderTransitionResponse;

/**
 * OK
 */
export const zOrdersV2MoveOrderToTelehealthPostVisitCompletedResponse = zOrderTransitionResponse;

/**
 * OK
 */
export const zOrdersV2MoveOrderToTelehealthUpcomingResponse = zOrderTransitionResponse;

/**
 * OK
 */
export const zPatientsV2HeartbeatResponse = zHeartbeat;

/**
 * OK
 */
export const zPatientsV2SearchPatientsResponse = zSearchPatientResultsResponse;

/**
 * OK
 */
export const zPatientsV2PatientDetailsResponse = zPatientDetailResponse;

/**
 * OK
 */
export const zPatientsV2PatientAddressesResponse = zPatientAddressesResponse;

/**
 * OK
 */
export const zPatientsV2PatientContactsResponse = zPatientContactsResponse;

/**
 * OK
 */
export const zPatientsV2PatientInsurancesResponse = zPatientInsurancesResponse;

/**
 * OK
 */
export const zPatientsV2PatientOrdersResponse = zPatientOrdersResponse;

/**
 * OK
 */
export const zPatientsV2ReassignPatientResponse = zReassignPatientResponse;

/**
 * OK
 */
export const zProductsV2CarrierCoverageZoneProductsV2CreateCarrierCoverageZoneProductResponse = zCczpCreateResponse;

/**
 * OK
 */
export const zProductsV2CarrierCoverageZoneProductsV2HeartbeatResponse = zHeartbeat;

/**
 * OK
 */
export const zProductsV2CarrierCoverageZoneProductsV2GetCarrierCoverageZoneProductDetailsResponse = zCczpDetails;

export const zProductsV2CarrierCoverageZoneProductsV2DeleteCarrierCoverageZoneProductResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

/**
 * OK
 */
export const zProductsV2CarrierCoverageZoneProductsV2EditCarrierCoverageZoneProductResponse = zCczpEditResponse;

/**
 * No Content
 */
export const zProductsV2CartV2DeleteCartResponse = zCart;

/**
 * OK
 */
export const zProductsV2CartV2GetCartResponse = zCart;

/**
 * Created
 */
export const zPostProductsV2CartV2CreateUpdateCartResponse = zCart;

/**
 * Created
 */
export const zPutProductsV2CartV2CreateUpdateCartResponse = zCart;

/**
 * OK
 */
export const zProductsV2CategoriesV2GetAllCategoriesResponse = z.array(zProductCategory1).register(z.globalRegistry, {
    description: 'OK'
});

/**
 * OK
 */
export const zProductsV2CategoriesV2HeartbeatResponse = zHeartbeat;

/**
 * No Content
 */
export const zProductsV2CategoriesV2SearchCategoriesResponse = z.void().register(z.globalRegistry, {
    description: 'No Content'
});

/**
 * OK
 */
export const zProductsV2HeartbeatResponse = zHeartbeat;

/**
 * OK
 */
export const zProductsV2SearchProductsResponse = zSearchResults;

export const zProductsV2FoldProductsResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

export const zProductsV2FoldProducts2Response = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

export const zProductsV2FoldProducts3Response = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

export const zProductsV2FoldProducts4Response = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

/**
 * OK
 */
export const zProductsV2GetProductDetailsResponse = zProductDetails;

/**
 * OK
 */
export const zProductsV2EditProductResponse = zProductDetails;

/**
 * OK
 */
export const zServicesV2FrontrunnerV2HeartbeatResponse = zHeartbeat;

/**
 * No Content
 */
export const zServicesV2FrontrunnerV2PipelineReplayResponse = z.void().register(z.globalRegistry, {
    description: 'No Content'
});

/**
 * OK
 */
export const zServicesV2HeartbeatResponse = zHeartbeat;

/**
 * OK
 */
export const zSuppliersV2GetAllSuppliersResponse = zSupplierListResponse;

/**
 * OK
 */
export const zSuppliersV2DetailsResponse = zSupplierDetailResponse;

/**
 * OK
 */
export const zSuppliersV2HeartbeatResponse = zHeartbeat;

/**
 * OK
 */
export const zSuppliersV2SearchResponse = zSearchSupplierResponse;

/**
 * OK
 */
export const zSuppliersV2Search2Response = zSearchSupplierResponse;

/**
 * OK
 */
export const zInsuranceV3CardUploadUrlResponse = zInsuranceCardUploadUrlResponse;

/**
 * OK
 */
export const zInsuranceV3PutCardsResponse = zInsuranceCardsResponse;

/**
 * OK
 */
export const zInsuranceV3CarrierStatusesV3ListCarrierStatusesResponse = zCarrierStatusListResponse;

/**
 * Created
 */
export const zInsuranceV3CarriersV3CreateCarrierResponse = zCarrierDetailResponse;

/**
 * OK
 */
export const zInsuranceV3CarriersV3SearchCarriersResponse = zCarrierListResponse;

/**
 * OK
 */
export const zInsuranceV3CarriersV3UpdateCarrierResponse = zCarrierDetailResponse;

/**
 * OK
 */
export const zInsuranceV3GetCarriersByStateResponse = z.array(zCarrierSchemaV3).register(z.globalRegistry, {
    description: 'OK'
});

/**
 * OK
 */
export const zInsuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverridesResponse = zCodeEligibilityOverrideList;

/**
 * OK
 */
export const zInsuranceV3CodeEligibilityOverridesV3CreateCodeEligibilityOverrideResponse = zCodeEligibilityOverrideResponse;

export const zInsuranceV3CodeEligibilityOverridesV3DeleteCodeEligibilityOverrideResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'OK'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

/**
 * OK
 */
export const zInsuranceV3CodeEligibilityOverridesV3UpdateCodeEligibilityOverrideResponse = zCodeEligibilityOverrideResponse;

/**
 * OK
 */
export const zInsuranceV3CoverageZonesV3ListCoverageZonesResponse = zCoverageZoneListResponse;

/**
 * OK
 */
export const zInsuranceV3HeartbeatResponse = zHeartbeat;

/**
 * OK
 */
export const zInsuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignationsResponse = zNetworkStatusDesignationList;

/**
 * OK
 */
export const zInsuranceV3NetworkStatusDesignationsV3CreateNetworkStatusDesignationResponse = zNetworkStatusDesignationResponse;

export const zInsuranceV3NetworkStatusDesignationsV3DeleteNetworkStatusDesignationResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'OK'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

/**
 * OK
 */
export const zInsuranceV3NetworkStatusDesignationsV3UpdateNetworkStatusDesignationResponse = zNetworkStatusDesignationResponse;

/**
 * Created
 */
export const zInsuranceV3PlanCodesV3CreatePlanCodeResponse = zPlanCodeDetailResponse;

/**
 * OK
 */
export const zInsuranceV3PlanCodesV3SearchPlanCodesResponse = zPlanCodeListResponse;

/**
 * OK
 */
export const zInsuranceV3PlanCodesV3GetPlanCodeResponse = zPlanCodeDetailResponse;

/**
 * OK
 */
export const zInsuranceV3PlanCodesV3UpdatePlanCodeResponse = zPlanCodeDetailResponse;

/**
 * Created
 */
export const zInsuranceV3PlansV3CreatePlanResponse = zPlanDetailResponse;

/**
 * OK
 */
export const zInsuranceV3PlansV3SearchPlansResponse = zPlanListResponse;

/**
 * OK
 */
export const zInsuranceV3PlansV3GetPlanResponse = zPlanDetailResponse;

/**
 * OK
 */
export const zInsuranceV3PlansV3UpdatePlanResponse = zPlanDetailResponse;

/**
 * OK
 */
export const zInsuranceV3DiscoveryResponse = zInsuranceEligibilityDiscoveryResponse;

/**
 * OK
 */
export const zInsuranceV3TestVerificationKeyResponse = zInsuranceEligibilityDiscoveryResponse;

/**
 * OK
 */
export const zInsuranceV3VerificationResponse = zInsuranceEligibilityVerificationResponse;

/**
 * OK
 */
export const zProductsV3GetProductsResponse = zProductListResponse;

/**
 * OK
 */
export const zProductsV3GetCategoriesResponse = zCategoriesResponse;

/**
 * OK
 */
export const zProductsV3GetCoverageZonesResponse = zCoverageZonesResponse;

/**
 * OK
 */
export const zProductsV3ExportCatalogResponse = zFlatCatalogResponse;

/**
 * OK
 */
export const zProductsV3ExportCatalog2Response = zFlatCatalogResponse;

/**
 * OK
 */
export const zProductsV3HeartbeatResponse = zHeartbeat;

/**
 * OK
 */
export const zSchedulingV3GetSlotsResponse = zTimeSlotsResponse;

/**
 * OK
 */
export const zSchedulingV3ReserveSlotResponse = zTimeSlotReservationResponse;

export const zSchedulingV3CalcomWebhookResponse = z.union([
    z.unknown().register(z.globalRegistry, {
        description: 'application/json'
    }),
    z.void().register(z.globalRegistry, {
        description: 'No Content'
    })
]);

/**
 * OK
 */
export const zSessionsV3PreviewSessionResponse = zEmptyResponse;

/**
 * OK
 */
export const zSessionsV3SaveSessionResponse = zUserSessionSaveResponse;

/**
 * OK
 */
export const zSessionsV3VerifySessionResponse = zUserSessionVerifyResponse;

/**
 * OK
 */
export const zVerifyV3CheckResponse = zVerifyCheckResponse;

/**
 * OK
 */
export const zVerifyV3StartResponse = zVerifyStartResponse;

/**
 * Created
 */
export const zOrdersV4CreateOrderDtcEndpointResponse = zCreateOrderResponse;

/**
 * Created
 */
export const zOrdersV4CreateOrderMcpEndpointResponse = zCreateOrderResponse;

/**
 * No Content
 */
export const zOrdersV4EscalateMcpOrderResponse = z.void().register(z.globalRegistry, {
    description: 'No Content'
});

/**
 * OK
 */
export const zOrdersV4PatchManualVerificationResponse = zManualVerificationResponse;

/**
 * OK
 */
export const zProductsV4GetProductAuditResponse = zAuditResponse;

/**
 * OK
 */
export const zProductsV4GetCarriersResponse = z.array(zCarrierByState).register(z.globalRegistry, {
    description: 'OK'
});

/**
 * OK
 */
export const zProductsV4GetCatalogProductsResponse = zCatalogListResponse;

/**
 * OK
 */
export const zProductsV4GetCatalogProductResponse = zCatalogProductResponse;

/**
 * OK
 */
export const zProductsV4GetAllCategoriesResponse = z.array(zProductCategory1).register(z.globalRegistry, {
    description: 'OK'
});

/**
 * No Content
 */
export const zProductsV4SearchCategoriesResponse = z.void().register(z.globalRegistry, {
    description: 'No Content'
});

/**
 * OK
 */
export const zProductsV4GetCoverageZonesResponse = z.array(zCoverageZone).register(z.globalRegistry, {
    description: 'OK'
});

/**
 * OK
 */
export const zProductsV4GetFeeScheduleResponse = zFeeScheduleResults;

/**
 * OK
 */
export const zProductsV4SearchProductsResponse = zSearchResults;

/**
 * OK
 */
export const zProductsV4GetProductDetailResponse = zAdminProductDetails;

/**
 * OK
 */
export const zSchedulingV4GetAppointmentResponse = zGetAppointmentResponse;

/**
 * OK
 */
export const zSchedulingV4CancelAppointmentResponse = zCancelAppointmentResponse;

/**
 * OK
 */
export const zSchedulingV4GetDaysResponse = zDaysAvailableResponse;

/**
 * OK
 */
export const zSchedulingV4RescheduleAppointmentResponse = zRescheduleAppointmentResponse;

/**
 * OK
 */
export const zSchedulingV4BookSelfScheduledAppointmentResponse = zBookAppointmentResponse;

/**
 * OK
 */
export const zSchedulingV4VerifyPatientBookingResponse = zVerifyPatientBookingResponse;

/**
 * OK
 */
export const zSchedulingV4GetSlotsResponse = zTimeSlotsResponse1;

/**
 * OK
 */
export const zTrackingV4VerifyAndGetTrackingResponse = zTrackingVerifyResponse;

/**
 * OK
 */
export const zOrdersV5OrderDetailsResponse = zOrderDetailResponse;
